import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import {
  Trash2,
  Plus,
  Minus,
  ShoppingCart,
  Package,
  CreditCard,
  Truck,
  CheckCircle,
  Timer,
  Shield,
  Zap,
  Upload,
  Eye,
  MapPin,
  FileText,
  Pencil,
  Check,
  X,
  Percent,
  Copy,
} from "lucide-react";
import OurLayouts from "./layout/index";
import axios from "axios";
import Labimg from "../assets/labtest_icon.svg";
import PaymentModeModal from "./PatientRegister/PaymentModeModal";
import {
  getMedicineIconBoxClassName,
  renderMedicineTypeIcon,
} from "./BookService/medicineTypeIcon";
import { toast } from "react-toastify";
import moment from "moment";
import PreferedDateAndTime from "./PreferedDateAndTime";
import ConsentModal from "./Consent/ConsentModal";
import { ClimbingBoxLoader } from "react-spinners";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { getHospitalDetails } from "../utils/hospitalStorage";

const CART_SECTION_HEADER_GRADIENT =
  "linear-gradient(90deg, #D4EDE9 0%, #FFFFFF 100%)";

const PATIENT_STRIP_GRADIENT =
  "linear-gradient(90deg, #D4EDE9 0%, #FFFFFF 100%)";

const CART_CARD_STYLE = {
  border: "1px solid #E5E7EB",
  borderRadius: 12,
  boxShadow: "0 1px 4px rgba(0,0,0,0.05)",
};

const AVAILABLE_COUPONS = [
  {
    code: "CB_MED10",
    rxDiscount: "Flat 10% discount on Rx medicines",
    otcDiscount: "Flat 2% discount on OTC medicines",
  },
];

export default function MedicineCartPage() {
  const pdfRef = useRef();
  const [isGeneratingPDF, setIsGeneratingPDF] = useState(false);

  const API_URL = process.env.REACT_APP_API_URL;
  const navigate = useNavigate();
  const location = useLocation();
  const [medicines, setMedicines] = useState([]);
  const [loading, setLoading] = useState(true);
  const [cartId, setCartId] = useState(null);
  const [removingItems, setRemovingItems] = useState(new Set());
  const [updatingQuantity, setUpdatingQuantity] = useState(new Set());
  const patientId = location.state?.patientId;
  const selectedPatient = location.state?.selectedPatient;
  const prescriptionData = location.state?.abdmData;
  console.log( selectedPatient, "selectedPatientjhbjhbj");
  const [cartList, setCartList] = useState([]);
  const [labCartDetails, setLabCartDetails] = useState(null);
  const [labtests, setlabtests] = useState([]);
  const [labTestBill, setLabTestBill] = useState(0);
  const [medicineBill, setMedicineBill] = useState(0);
  const [totalDiscount, setTotalDiscount] = useState(0);
  const [totalAmount, setTotalAmount] = useState(0);
  const [orderid, setorderid] = useState("");
  const [modalOpen, setModalOpen] = useState(false);
  const [paymentMode, setPaymentMode] = useState("");
  const [isLoggingIn, setIsLoggingIn] = useState(false);
  const [medicineDetails, setMedicineDetails] = useState();
  const [preferDate, setPreferDate] = useState(
    moment(new Date()).format("YYYY-MM-DD")
  );
  const [patientDetails, setPatientDetails] = useState({});
  const [preferModalOpen, setPreferModalOpen] = useState(false);
  const [addressModalOpen, setaddressModalOpen] = useState(false);
  const [preferTime, setPreferTime] = useState("");
  const [addressOption, setAddressOption] = useState("clinic");
  const [preferDateupdate, setPreferDateupdate] = useState("");
  const [patientAddresses, setPatientAddresses] = useState([]);
  const [selectedAddress, setSelectedAddress] = useState(null);
  const [editAddressModalOpen, setEditAddressModalOpen] = useState(false);
  const [addressToEdit, setAddressToEdit] = useState(null);
  
  // Edit form state
  const [editHouseNo, setEditHouseNo] = useState("");
  const [editAddress1, setEditAddress1] = useState("");
  const [editPincode, setEditPincode] = useState("");
  const [editFetchedState, setEditFetchedState] = useState("");
  const [editFetchedCountry, setEditFetchedCountry] = useState("India");
  const [editErrors, setEditErrors] = useState({});

  // Fetch address details by pincode for edit form
  const fetchEditAddressByPincode = async (pincode) => {
    try {
      const token = localStorage.getItem("auth_token");
      const tenantId = localStorage.getItem("tenantId");
      
      const response = await axios.get(
        `${process.env.REACT_APP_NEWBASEURL}getAllAddressDetails/list?pincode=${pincode}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            tenantId: tenantId,
          },
        }
      );
      
      console.log("Edit Address API response:", response.data.data);
      
      if (response.data.data && response.data.data.length > 0) {
        const addressData = response.data.data[0];
        
        // Update edit form state variables
        setEditFetchedState(addressData.state || "");
        setEditFetchedCountry("India");
        
        console.log("Edit Address fields updated:", {
          state: addressData.state,
          country: "India"
        });
      }
    } catch (error) {
      console.error("Error fetching edit address details:", error);
      toast.error("Failed to fetch address details");
    }
  };

  // Handle edit address form submission
  const handleEditAddressSubmit = async () => {
    // Validate required fields before updating address
    const errors = {};
    if (!editHouseNo.trim()) {
      errors.editHouseNo = "House number is required";
    } else if (editHouseNo.trim().length < 2) {
      errors.editHouseNo = "House number must be at least 2 characters";
    }
    
    if (!editAddress1.trim()) {
      errors.editAddress1 = "Landmark is required";
    } else if (editAddress1.trim().length < 3) {
      errors.editAddress1 = "Landmark must be at least 3 characters";
    }
    
    if (!editPincode.trim()) {
      errors.editPincode = "Pincode is required";
    } else if (!/^\d{6}$/.test(editPincode)) {
      errors.editPincode = "Pincode must be exactly 6 digits";
    }
    
    // If there are validation errors, show them and return
    if (Object.keys(errors).length > 0) {
      // Show first error
      const firstError = Object.values(errors)[0];
      toast.error(firstError);
      return;
    }

    try {
      const token = localStorage.getItem("auth_token");
      const tenantId = localStorage.getItem("tenantId");

      const payload = {
        address: editHouseNo,
        landmark: editAddress1,
        state: editFetchedState,
        pincode: editPincode,
        country: editFetchedCountry,
        patientId: patientId,
      };

      const response = await fetch(
        `${API_URL}addressbook/${addressToEdit.id}`,
        {
          method: "PUT",
          headers: { 
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`, 
              tenantId: tenantId 
            },
          body: JSON.stringify(payload),
        }
      );

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(`HTTP error! status: ${response.status}, message: ${errorData.message || 'Unknown error'}`);
      }

      const responseData = await response.json();
      
      if (responseData && responseData.id) {
        toast.success("Address updated successfully!");
        
        // Update the address in the list
        setPatientAddresses(prev => 
          prev.map(addr => 
            addr.id === responseData.id ? responseData : addr
          )
        );
        
        // Update selected address if it was the one being edited
        if (selectedAddress?.id === addressToEdit.id) {
          setSelectedAddress(responseData);
        }
        
        setEditAddressModalOpen(false);
        setAddressToEdit(null);
      } else {
        toast.error("Address update failed - unexpected response");
      }
    } catch (error) {
      console.error("Edit address error:", error);
      toast.error(error.message || "Failed to update address");
    }
  };

  const [consentModalOpen, setConsentModalOpen] = useState(false);
  const [consentGiven, setConsentGiven] = useState(false);
  const [couponModalOpen, setCouponModalOpen] = useState(false);
  const [couponInput, setCouponInput] = useState("");
  const [appliedCoupon, setAppliedCoupon] = useState("");
  const [applyingCoupon, setApplyingCoupon] = useState(false);
  const [removingCoupon, setRemovingCoupon] = useState(false);

  const [addressupdate, setAddressupdate] = useState("");
  const [clinicaddress, setClinicaddress] = useState("");
  const [patientaddress, setPatientaddress] = useState("");
  
  // Add prescription upload states
  const [prescriptionUploaded, setPrescriptionUploaded] = useState(false);
  const [uploadingPrescription, setUploadingPrescription] = useState(false);
  const [prescriptionFile, setPrescriptionFile] = useState(null);
  const [prescriptionDocuments, setPrescriptionDocuments] = useState(null);
  const [checkingPrescription, setCheckingPrescription] = useState(false);
  const [prescriptionPreview, setPrescriptionPreview] = useState({ open: false, url: null });

  const changeDate = (date) => {
    setPreferDate(moment(date, "DD-MM-YYYY").format("YYYY-MM-DD"));

    date = moment(date, "DD-MM-YYYY").format("YYYY-MM-DD HH:mm:ss");
  };

  // Function to fetch address details by pincode
  const fetchAddressByPincode = async (pincode) => {
    try {
      const token = localStorage.getItem("auth_token");
      const tenantId = localStorage.getItem("tenantId");
      
      const response = await axios.get(
        `${process.env.REACT_APP_NEWBASEURL}getAllAddressDetails/list?pincode=${pincode}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            tenantId: tenantId,
          },
        }
      );
      
      console.log("Address API response:", response.data.data);
      
      if (response.data.data && response.data.data.length > 0) {
        const addressData = response.data.data[0]; // Take first entry since all have same state/district
        
        // Create area options for dropdown
        const areas = response.data.data.map(item => ({
          value: item.area,
          label: item.area,
          key: item.area
        }));
        setAreaOptions(areas);
        
        // Update state variables
        setFetchedState(addressData.state || "");
        setFetchedCity(addressData.area || ""); // Using area as city
        setFetchedCountry("India");
        
        // Update form fields
        setStateField(addressData.state || "");
        setCity(addressData.area || "");
        
        console.log("Address fields updated:", {
          state: addressData.state,
          city: addressData.area,
          country: "India"
        });
      }
    } catch (error) {
      console.error("Error fetching address details:", error);
      toast.error("Failed to fetch address details");
    }
  };
  const [houseNo, setHouseNo] = useState("");
  const [address1, setAddress1] = useState("");
  const [landmark, setLandmark] = useState("");
  const [pincode, setPincode] = useState("");
  const [city, setCity] = useState("");
  const [stateField, setStateField] = useState("");
  const [fetchedState, setFetchedState] = useState("");
  const [fetchedCity, setFetchedCity] = useState("");
  const [fetchedCountry, setFetchedCountry] = useState("");
  const [areaOptions, setAreaOptions] = useState([]);

  // Function to reset address form fields
  const resetAddressForm = () => {
    setHouseNo("");
    setAddress1("");
    setPincode("");
    setCity("");
    setFetchedState("");
    setFetchedCountry("");
    setStateField("");
  };
  const [deliveryaddress, setDeliveryaddress] = useState({
    address1: "",
    deliveryCity: "",
    deliveryState: "",
    deliveryCountry: "",
    deliveryPinCode: "",
  });
  const [prefereeddate, setPrefereeddate] = useState({
    date: "",
    time: "",
  });
  const hospitaldata = getHospitalDetails();
console.log(hospitaldata, "hospitalghvj");
  useEffect(() => {
    if (hospitaldata ) {
      setDeliveryaddress({
        address1: hospitaldata?.address, // or whatever you want
        deliveryCity: hospitaldata.city,
        deliveryState: hospitaldata.state,
        deliveryCountry: hospitaldata.country,
        deliveryPinCode: hospitaldata.pinCode,
      });
    }
  }, []);
  const handleChange = (e) => {
    let value = e?.target?.value;
    let time = convertTime(value.substring(0, 5));
    setPreferTime(value ? value : "");

    localStorage.setItem("preferTime", JSON.stringify(time));
    localStorage.setItem("preferValue", JSON.stringify(value));
    localStorage.setItem("preferDate", JSON.stringify(preferDate));
  };
  const convertTime = (timeStr) => {
    const [time, modifier] = timeStr.split(" ");
    let [hours] = time.split(":");
    if (hours === "12") {
      hours = "00";
    }
    if (modifier === "PM") {
      hours = parseInt(hours, 10) + 12;
    }
    return `${hours}`;
  };
  const fetchCartList = async () => {
    if (!patientDetails.curebayPatientId) return;
    const token = localStorage.getItem("auth_token");
    try {
      const { data } = await axios.get(
        `${process.env.REACT_APP_CARTURL}common/cart-list/${patientDetails.curebayPatientId}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setCartList(data.data.carts || []);
    } catch (err) {
      console.error("Failed to fetch cart list:", err.response?.data || err);
    }
  };

  useEffect(() => {
    fetchCartList();
  }, [patientDetails.curebayPatientId]);
 
  const prescriptionNeeded = medicineDetails?.medicineItems?.some(
    (item) => item.prescriptionRequired
  );

  useEffect(() => {
    if (!patientId) return;
    const checkConsent = async () => {
      // setLoading(true);
      const token = localStorage.getItem("auth_token");
      const tenantId = localStorage.getItem("tenantId");
      try {
        const res = await fetch(
          `${API_URL}patientConsent/by-patient?patientId=${patientId}&serviceType=CUREBAY_SERVICE&Status=1`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              tenantId: tenantId,
            },
          }
        );
        const data = await res.json();

        if (Array.isArray(data.data) && data.data.length > 0) {
        } else {
          setConsentGiven(true);
        }
      } catch (err) {}
    };
    checkConsent();
    // eslint-disable-next-line
  }, [selectedPatient]);
  useEffect(() => {
  
    fetchpatient();
    fetchpatientaddress();
   
  }, [patientId]);
  const fetchpatientaddress = async () => {
    const token = localStorage.getItem("auth_token");
    const tenantId = localStorage.getItem("tenantId");
    try {
      const response = await axios.get(
        `${API_URL}addressbook/getBy?patientId=${patientId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            tenantId: tenantId,
          },
        }
      );
      console.log(response.data, "dcftgyrftyytfyf");
      
      // Store all addresses in state
      if (response.data && Array.isArray(response.data)) {
        setPatientAddresses(response.data);
        // Set the first address as selected by default
        if (response.data.length > 0) {
          setSelectedAddress(response.data[0]);
        }
      }
    } catch (error) {
      console.error("Error fetching slots:", error);
    }
  };
  const fetchpatient = async () => {
    const token = localStorage.getItem("auth_token");
    const tenantId = localStorage.getItem("tenantId");
    try {
      const response = await axios.get(
        `${API_URL}patient/search?patientId=${patientId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            tenantId: tenantId,
          },
        }
      );
      console.log(response.data, "zsxdcfvghbjcfvgbh");
      const firstPatient = response?.data.data[0];
      console.log(firstPatient, "gfcghvhgtttttt");
      setPatientDetails(firstPatient);
    } catch (error) {
      console.error("Error fetching slots:", error);
    }
  };
  useEffect(() => {
    const fetchpincode = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_POSTALURL}${patientDetails?.pinCode}`,
          {
            headers: {
              // Authorization: `Bearer ${token}`,
            },
          }
        );
        console.log(response.data[0].PostOffice[0], "hjbbbnbj");
        // setClinicaddress(response.data[0].PostOffice[0]);
        setPatientaddress(response.data[0].PostOffice[0]);
      } catch (error) {
        console.error("Error fetching slots:", error);
      }
    };
    // const fetchclinicpincode = async () => {
    //   try {
    //     const response = await axios.get(
    //       `${process.env.REACT_APP_POSTALURL}751013`,
    //       {
    //         headers: {
    //           // Authorization: `Bearer ${token}`,
    //         },
    //       }
    //     );
    //     console.log(response.data[0].PostOffice[0], "jbkjbjkbjb");
    //     setClinicaddress(response.data[0].PostOffice[0]);
    //   } catch (error) {
    //     console.error("Error fetching slots:", error);
    //   }
    // };
    fetchpincode();
    // fetchclinicpincode();

    if (hospitaldata ) {
      setClinicaddress({
        address1: hospitaldata?.address, // or whatever you want
        deliveryCity: hospitaldata.city,
        deliveryState: hospitaldata.state,
        deliveryCountry: hospitaldata.country,
        deliveryPinCode: hospitaldata.pinCode,
      });
    }
  }, [patientDetails]);

  // 2. HTML GENERATION FUNCTION - Only returns HTML string

  // 3. PDF GENERATION FUNCTION - Only generates PDF
  // Enhanced PDF generation function that returns base64 and type information
  const generatePrescriptionPDFAsBase64 = async () => {
    setIsGeneratingPDF(true);

    try {
      // Get HTML content
      const htmlContent = generateHTMLContentExactFormat();
      if (!htmlContent) {
        throw new Error("Failed to generate HTML content");
      }

      // Create a temporary div with the HTML content
      const tempDiv = document.createElement("div");
      tempDiv.innerHTML = htmlContent;
      tempDiv.style.position = "absolute";
      tempDiv.style.left = "-9999px";
      tempDiv.style.width = "210mm"; // A4 width
      tempDiv.style.backgroundColor = "#ffffff";
      tempDiv.style.fontFamily = "Arial, sans-serif";
      document.body.appendChild(tempDiv);

      console.log("Generating canvas...");
      const canvas = await html2canvas(tempDiv, {
        scale: 2,
        useCORS: true,
        allowTaint: true,
        backgroundColor: "#ffffff",
        logging: false,
        width: tempDiv.scrollWidth,
        height: tempDiv.scrollHeight,
      });

      console.log("Creating PDF...");
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF("p", "mm", "a4");

      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = pdf.internal.pageSize.getHeight();
      const imgWidth = pdfWidth;
      const imgHeight = (canvas.height * pdfWidth) / canvas.width;

      let heightLeft = imgHeight;
      let position = 0;

      // Add first page
      pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
      heightLeft -= pdfHeight;

      // Add additional pages if content is longer than one page
      while (heightLeft >= 0) {
        position = heightLeft - imgHeight;
        pdf.addPage();
        pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
        heightLeft -= pdfHeight;
      }

      // Clean up
      document.body.removeChild(tempDiv);

      // Generate filename
      const patientName = `${patientDetails?.firstName || "Patient"}_${
        patientDetails?.lastName || "Name"
      }`;
      const timestamp = moment().format("YYYYMMDD_HHmmss");
      const fileName = `prescription_${patientName}_${timestamp}.pdf`;

      // Get PDF as different formats
      const pdfBlob = pdf.output("blob");
      const pdfArrayBuffer = pdf.output("arraybuffer");
      const pdfBase64 = pdf.output("datauristring"); // Full data URI with prefix
      const pdfBase64Clean = pdf.output("datastring"); // Clean base64 without prefix

      // File information
      const fileInfo = {
        // Base64 formats
        base64WithPrefix: pdfBase64, // "data:application/pdf;base64,JVBERi0xLjM..."
        base64Clean: pdfBase64Clean, // Clean base64 string without prefix

        // File details
        fileName: fileName,
        fileSize: pdfBlob.size,
        fileSizeFormatted: formatFileSize(pdfBlob.size),

        // MIME type and extension
        mimeType: "application/pdf",
        fileExtension: "pdf",
        contentType: "application/pdf",

        // Additional info
        timestamp: timestamp,
        patientName: patientName,

        // For upload purposes
        blob: pdfBlob,
        arrayBuffer: pdfArrayBuffer,
      };

      console.log("PDF Information:", fileInfo);

      // // Save the PDF (optional)
      // pdf.save(fileName);

      // Return the file information for further use
      return fileInfo;
    } catch (error) {
      console.error("Error generating PDF:", error);
      toast.error(`Failed to generate PDF: ${error.message}`);
      throw error;
    } finally {
      setIsGeneratingPDF(false);
    }
  };

  // Helper function to format file size
  const formatFileSize = (bytes) => {
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const sizes = ["Bytes", "KB", "MB", "GB"];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
  };

  const generatePrescriptionPDF = async () => {
    setIsGeneratingPDF(true);

    try {
      const htmlContent = generateHTMLContentExactFormat();
      console.log(htmlContent, "htmlContent");

      if (!htmlContent) {
        throw new Error("HTML content is empty");
      }

      const tempDiv = document.createElement("div");
      tempDiv.innerHTML = htmlContent;
      tempDiv.style.position = "absolute";
      tempDiv.style.left = "-9999px";
      tempDiv.style.top = "0";
      tempDiv.style.width = "210mm";
      tempDiv.style.backgroundColor = "#ffffff";
      tempDiv.style.fontFamily = "Arial, sans-serif";
      document.body.appendChild(tempDiv);

      console.log("HTML content loaded, generating canvas...");

      const canvas = await html2canvas(tempDiv, {
        scale: 0.75,
        useCORS: true,
        allowTaint: true,
        backgroundColor: "#ffffff",
      });

      console.log("Canvas generated, creating PDF...");

      const imgData = canvas.toDataURL("image/jpeg", 0.5);
      const pdf = new jsPDF("p", "mm", "a4");

      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = pdf.internal.pageSize.getHeight();
      const imgWidth = pdfWidth;
      const imgHeight = (canvas.height * pdfWidth) / canvas.width;

      let heightLeft = imgHeight;
      let position = 0;

      pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
      heightLeft -= pdfHeight;

      while (heightLeft > 0) {
        position = heightLeft - imgHeight;
        pdf.addPage();
        pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
        heightLeft -= pdfHeight;
      }

      document.body.removeChild(tempDiv);

      // ✅ Get only the base64 string without data URI prefix
      const base64 = pdf.output("datauristring").split(",")[1];
      console.log("PDF generated successfully, base64 length:", base64.length);

      return base64;
    } catch (error) {
      console.error("Error generating PDF:", error);
      throw error;
    } finally {
      setIsGeneratingPDF(false);
    }
  };

  const uploadPrescriptionToAPI = async () => {
    try {
      const pdfBase64 = await generatePrescriptionPDF();

      console.log(pdfBase64, "hgvhjvjhbjk");
      const uploadPayload = {
        patientId: patientDetails.curebayPatientId,
        orderId: medicineDetails?.patientOrderId,
        orderType: "MED",
        prescriptionDocuments: [
          {
            prescriptionDocData: pdfBase64,
            prescriptionDocType: "pdf",
          },
        ],
      };

      console.log("Upload Payload:", uploadPayload);

      const response = await fetch(
        `${process.env.REACT_APP_CARTURL}common/upload-prescription`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            // Authorization: `Bearer ${token}`, // Add if needed
          },
          body: JSON.stringify(uploadPayload),
        }
      );

      const result = await response.json();
      console.log("Upload Result:", result);

      // if (result.status === 200) {
      //   toast.success("Prescription uploaded successfully!");
      //   return result;
      // }
    } catch (error) {
      console.error("Upload error:", error);
      toast.error("Failed to upload prescription");
      throw error;
    }
  };

  // Enhanced generateHTMLContent with better spacing and padding
  // Updated generateHTMLContent with exact format and better padding
  const generateHTMLContentExactFormat = () => {
    const doctorName =
      prescriptionData?.doctorName || "Doctor Name Not Available";
    const patientName =
      `${patientDetails?.firstName || ""} ${
        patientDetails?.lastName || ""
      }`.trim() || "Patient Name Not Available";
    const patientAge = patientDetails?.age || "N/A";
    const patientGender = patientDetails?.gender || "N/A";
    const patientPhone = patientDetails?.mobileNumber || "N/A";
    const hospitalName = prescriptionData?.prescription?.clinicId || "N/A";
    const visitDate = prescriptionData?.prescription?.visitDate || "N/A";

    const getVisitTypeDisplay = (visitType) => {
      if (!visitType) return "N/A";
      switch (visitType.toLowerCase()) {
        case "v":
          return "Video Consultation";
        case "q":
          return "Quick Consultation";
        case "i":
          return "In-Person Consultation";
        case "ic":
          return "In Eclinic Consultation";
        default:
          return visitType;
      }
    };

    const getSymptomsList = () => {
      const symptoms = prescriptionData?.prescription?.symptomsList;
      if (!symptoms || !Array.isArray(symptoms) || symptoms.length === 0) {
        return "No findings available";
      }
      return symptoms
        .map((item) => item?.symptomsName || "Unknown symptom")
        .join(", ");
    };

    const getMedicinesTable = () => {
      const drugList =
        prescriptionData?.prescription?.patientDrugPrescriptionList;
      if (!drugList || !Array.isArray(drugList) || drugList.length === 0) {
        return `<tr><td colspan="7" style="text-align: center; padding: 15px; color: #666;">No medications prescribed</td></tr>`;
      }

      return drugList
        .map(
          (drug, i) => `
      <tr>
        <td style="text-align: center; padding: 12px 8px; border-right: 1px solid #ddd;">${
          i + 1
        }</td>
        <td style="padding: 12px 8px; border-right: 1px solid #ddd;">
          <div style="font-weight: 600;">${
            drug?.drugName || "Unknown Medicine"
          }</div>
          ${
            drug?.composition
              ? `<div style="font-size: 0.9em; color: #666; margin-top: 2px;">${drug.composition}</div>`
              : ""
          }
        </td>
        <td style="padding: 12px 8px; text-align: center; border-right: 1px solid #ddd;">${
          drug?.dosage || "N/A"
        }</td>
        <td style="padding: 12px 8px; text-align: center; border-right: 1px solid #ddd;">${
          drug?.quantity || "N/A"
        }</td>
        <td style="padding: 12px 8px; border-right: 1px solid #ddd;">${
          drug?.notes || ""
        }</td>
        <td style="padding: 12px 8px; text-align: center; border-right: 1px solid #ddd;">${
          drug?.instruction === "0"
            ? "After Meal"
            : drug?.instruction === "1"
            ? "Before Meal"
            : "N/A"
        }</td>
        <td style="padding: 12px 8px; text-align: center;">${
          drug?.duration || "N/A"
        } days</td>
      </tr>
    `
        )
        .join("");
    };

    const getLabTestsTable = () => {
      const labTests = prescriptionData?.prescription?.patientLabTestsList;
      if (!labTests || !Array.isArray(labTests) || labTests.length === 0) {
        return `
        <table style="width: 100%; border-collapse: collapse; margin-top: 15px;">
          <thead>
            <tr style="background-color: #f5f5f5;">
              <th style="padding: 12px; text-align: center; border: 1px solid #ddd; font-weight: bold;">S.NO</th>
              <th style="padding: 12px; text-align: center; border: 1px solid #ddd; font-weight: bold;">Name</th>
              <th style="padding: 12px; text-align: center; border: 1px solid #ddd; font-weight: bold;">Test Type</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td colspan="3" style="text-align: center; padding: 15px; color: #666; border: 1px solid #ddd;">No lab tests prescribed</td>
            </tr>
          </tbody>
        </table>
      `;
      }

      return `
      <table style="width: 100%; border-collapse: collapse; margin-top: 15px;">
        <thead>
          <tr style="background-color: #f5f5f5;">
            <th style="padding: 12px; text-align: center; border: 1px solid #ddd; font-weight: bold;">S.NO</th>
            <th style="padding: 12px; text-align: center; border: 1px solid #ddd; font-weight: bold;">Name</th>
            <th style="padding: 12px; text-align: center; border: 1px solid #ddd; font-weight: bold;">Test Type</th>
          </tr>
        </thead>
        <tbody>
          ${labTests
            .map(
              (test, i) => `
            <tr>
              <td style="text-align: center; padding: 12px; border: 1px solid #ddd;">${
                i + 1
              }</td>
              <td style="padding: 12px; border: 1px solid #ddd;">${
                test?.labTestName || "Unknown Test"
              }</td>
              <td style="text-align: center; padding: 12px; border: 1px solid #ddd;">Pathology</td>
            </tr>
          `
            )
            .join("")}
        </tbody>
      </table>
    `;
    };

    const getFollowUpDate = () => {
      const followUpDate = prescriptionData?.prescription?.followUpVisitDate;
      if (!followUpDate) return "";
      return followUpDate.split(" ")[0];
    };

    return `
    <html>
      <head>
        <style>
          * {
            margin: 0;
            padding: 0;
            box-sizing: border-box;
          }
          
          body { 
            font-family: Arial, sans-serif; 
            padding: 40px;
            margin: 0;
            background-color: #ffffff;
            line-height: 1.4;
            color: #000;
            font-size: 14px;
          }
          
          .header-section {
            margin-bottom: 20px;
          }
          
          .doctor-name {
            font-size: 18px;
            font-weight: bold;
            color: #005d8d;
            margin-bottom: 5px;
          }
          
          .doctor-id {
            font-size: 14px;
            color: #005d8d;
            margin-bottom: 15px;
          }
          
          .divider { 
            background-color: #005d8d; 
            height: 3px; 
            margin: 15px 0 25px 0;
          }
          
          .patient-info-table {
            width: 100%; 
            border-collapse: collapse; 
            margin-bottom: 25px;
          }
          
          .patient-info-table td { 
            padding: 8px 12px;
            border: 1px solid #ddd;
            vertical-align: top;
          }
          
          .info-label {
            font-weight: bold;
            background-color: #f5f5f5;
            width: 15%;
          }
          
          .info-value {
            width: 18%;
          }
          
          .section-header {
            font-weight: bold;
            font-size: 16px;
            margin: 25px 0 15px 0;
            text-decoration: underline;
          }
          
          .findings-text {
            margin-bottom: 25px;
            font-size: 14px;
          }
          
          .diagnosis-section {
            margin-bottom: 20px;
          }
          
          .diagnosis-title {
            font-weight: bold;
            font-size: 16px;
            margin-bottom: 10px;
            text-decoration: underline;
          }
          
          .diagnosis-item {
            margin-bottom: 10px;
            font-size: 14px;
          }
          
          .diagnosis-label {
            font-weight: bold;
            display: inline-block;
            margin-bottom: 5px;
          }
          
          .medicine-table {
            width: 100%;
            border-collapse: collapse;
            margin-top: 15px;
          }
          
          .medicine-table th { 
            background-color: #f5f5f5;
            padding: 12px 8px;
            border: 1px solid #ddd;
            font-weight: bold;
            text-align: center;
          }
          
          .medicine-table td {
            border: 1px solid #ddd;
          }
          
          .follow-up-section {
            margin: 25px 0;
            font-size: 14px;
          }
          
          .disclaimer-section {
            margin-top: 30px;
            font-size: 12px;
          }
          
          .disclaimer-title {
            font-weight: bold;
            margin-bottom: 10px;
          }
          
          .disclaimer-list {
            list-style: none;
            padding: 0;
          }
          
          .disclaimer-list li {
            margin-bottom: 5px;
            color: #666;
          }
        </style>
      </head>
      <body>
        <div class="header-section">
          <div class="doctor-name">Dr. ${doctorName}</div>
       
          <div class="divider"></div>
        </div>

        <table class="patient-info-table">
          <tr>
            <td class="info-label">Name:</td>
            <td class="info-value">${patientName}</td>
            <td class="info-label">Age/Sex:</td>
            <td class="info-value">${patientAge} / ${patientGender}</td>
            <td class="info-label">Hospital:</td>
            <td class="info-value">${hospitalName}</td>
          </tr>
          <tr>
            <td class="info-label">Phone Number:</td>
            <td class="info-value">${patientPhone}</td>
            <td class="info-label">Visit Type:</td>
            <td class="info-value">${getVisitTypeDisplay(
              prescriptionData?.prescription?.visitType
            )}</td>
            <td class="info-label">Visit Date:</td>
            <td class="info-value">${visitDate}</td>
          </tr>
        </table>

        <div class="section-header">Findings:</div>
        <div class="findings-text">${getSymptomsList()}</div>

        <div class="diagnosis-section">
          <div class="diagnosis-title">Primary Diagnosis:</div>
          <div class="diagnosis-item">
            <div class="diagnosis-label">ICD-10 :</div>
            <div>${prescriptionData?.prescription?.primarySymptoms || ""}</div>
          </div>
          <div class="diagnosis-item">
            <div class="diagnosis-label">Description :</div>
            <div>${prescriptionData?.prescription?.primaryDiagnosis || ""}</div>
          </div>
        </div>

        <div class="diagnosis-section">
          <div class="diagnosis-title">Secondary Diagnosis:</div>
          <div class="diagnosis-item">
            <div class="diagnosis-label">ICD-10 :</div>
            <div>${
              prescriptionData?.prescription?.secondarySymptoms || ""
            }</div>
          </div>
          <div class="diagnosis-item">
            <div class="diagnosis-label">Description :</div>
            <div>${
              prescriptionData?.prescription?.secondaryDiagnosis || ""
            }</div>
          </div>
        </div>

        ${
          prescriptionData?.prescription?.symptoms
            ? `
          <div class="diagnosis-section">
            <div class="diagnosis-title">Symptoms:</div>
            <div class="findings-text">${prescriptionData.prescription.symptoms}</div>
          </div>
        `
            : ""
        }

        <div class="section-header">Medicines Prescribed:</div>
        <table class="medicine-table">
          <thead>
            <tr>
              <th style="width: 8%;">#</th>
              <th style="width: 30%;">Medication</th>
              <th style="width: 12%;">Dosage</th>
              <th style="width: 8%;">Qty</th>
              <th style="width: 15%;">Notes</th>
              <th style="width: 15%;">Instruction</th>
              <th style="width: 12%;">Duration</th>
            </tr>
          </thead>
          <tbody>
            ${getMedicinesTable()}
          </tbody>
        </table>

        <div class="section-header">Lab Test Prescribed:</div>
        ${getLabTestsTable()}

        ${
          prescriptionData?.prescription?.recommendation
            ? `
          <div class="diagnosis-section">
            <div class="diagnosis-title">Recommendation:</div>
            <div class="findings-text">${prescriptionData.prescription.recommendation}</div>
          </div>
        `
            : ""
        }

        <div class="follow-up-section">
          Scheduled follow-up visit date: ${getFollowUpDate()}
        </div>

        <div class="disclaimer-section">
          <div class="disclaimer-title">Disclaimer:</div>
          <ul class="disclaimer-list">
            <li>* The information provided is provisional based on limited information.</li>
            <li>* The patient is advised to visit for a thorough examination.</li>
            <li>* The information is confidential and for recipient's use only.</li>
            <li>* The Prescription is generated on a Teleconsultation.</li>
            <li>* Not valid for medico-legal purposes.</li>
          </ul>
        </div>
      </body>
    </html>
  `;
  };

  const generateHTMLContentWithBetterSpacing = async () => {
    setIsGeneratingPDF(true); // Optional: loading state

    try {
      const htmlContent = generateHTMLContentExactFormat(); // Your custom HTML content as string
      console.log(htmlContent, "htmlContent");

      if (!htmlContent) {
        throw new Error("HTML content is empty");
      }

      // Create a hidden div for rendering HTML
      const tempDiv = document.createElement("div");
      tempDiv.innerHTML = htmlContent;
      tempDiv.style.position = "absolute";
      tempDiv.style.left = "-9999px";
      tempDiv.style.top = "0";
      tempDiv.style.width = "210mm"; // A4 size
      tempDiv.style.backgroundColor = "#ffffff";
      tempDiv.style.fontFamily = "Arial, sans-serif";

      document.body.appendChild(tempDiv);

      // Convert HTML to Canvas
      const canvas = await html2canvas(tempDiv, {
        scale: 1.5, // Lower scale to reduce size if needed
        useCORS: true,
        allowTaint: true,
        backgroundColor: "#ffffff",
        width: tempDiv.scrollWidth,
        height: tempDiv.scrollHeight,
      });

      console.log("Canvas generated, creating PDF...");

      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF("p", "mm", "a4");

      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = pdf.internal.pageSize.getHeight();
      const imgWidth = pdfWidth;
      const imgHeight = (canvas.height * pdfWidth) / canvas.width;

      let heightLeft = imgHeight;
      let position = 0;

      // First page
      pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
      heightLeft -= pdfHeight;

      // Additional pages if needed
      while (heightLeft > 0) {
        position = heightLeft - imgHeight;
        pdf.addPage();
        pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
        heightLeft -= pdfHeight;
      }

      document.body.removeChild(tempDiv); // Clean up

      // ✅ Get Base64 string
      const base64 = pdf.output("datauristring");
      console.log("PDF generated successfully, base64 length:", base64.length);

      // Optional: Download automatically
      const downloadLink = document.createElement("a");
      downloadLink.href = base64;
      downloadLink.download = "prescription.pdf";
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);

      return base64; // Return Base64 for API use or elsewhere
    } catch (error) {
      console.error("Error generating PDF:", error);
      throw error;
    } finally {
      setIsGeneratingPDF(false); // Reset loading state
    }
  };
  const generatePDFWithValidation = async () => {
    console.log("Starting PDF generation...");

    // Call validation function

    setIsGeneratingPDF(true);

    try {
      // Use the safe HTML generation function
      const htmlContent = generateHTMLContentWithBetterSpacing();
      if (!htmlContent) {
        throw new Error("Failed to generate HTML content");
      }

      // Create a temporary div with the HTML content
      const tempDiv = document.createElement("div");
      tempDiv.innerHTML = htmlContent;
      tempDiv.style.position = "absolute";
      tempDiv.style.left = "-9999px";
      tempDiv.style.width = "210mm";
      tempDiv.style.backgroundColor = "#ffffff";
      tempDiv.style.fontFamily = "Arial, sans-serif";
      document.body.appendChild(tempDiv);

      console.log("Generating canvas...");
      const canvas = await html2canvas(tempDiv, {
        scale: 2,
        useCORS: true,
        allowTaint: true,
        backgroundColor: "#ffffff",
        logging: false,
        width: tempDiv.scrollWidth,
        height: tempDiv.scrollHeight,
      });

      console.log("Creating PDF...");
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF("p", "mm", "a4");

      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = pdf.internal.pageSize.getHeight();
      const imgWidth = pdfWidth;
      const imgHeight = (canvas.height * pdfWidth) / canvas.width;

      let heightLeft = imgHeight;
      let position = 0;

      pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
      heightLeft -= pdfHeight;

      while (heightLeft >= 0) {
        position = heightLeft - imgHeight;
        pdf.addPage();
        pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
        heightLeft -= pdfHeight;
      }

      // Clean up
      document.body.removeChild(tempDiv);

      // Generate filename
      const patientName = `${patientDetails?.firstName || "Patient"}_${
        patientDetails?.lastName || "Name"
      }`;
      const timestamp = moment().format("YYYYMMDD_HHmmss");
      const fileName = `prescription_${patientName}_${timestamp}.pdf`;

      // Save the PDF
      pdf.save(fileName);

      console.log("PDF generated successfully!");
      toast.success("Prescription PDF downloaded successfully!");
    } catch (error) {
      console.error("Error generating PDF:", error);
      toast.error(`Failed to generate PDF: ${error.message}`);
    } finally {
      setIsGeneratingPDF(false);
    }
  };

  useEffect(() => {
    if (!patientDetails.curebayPatientId) return;

    const token = localStorage.getItem("auth_token");
    const url = `${process.env.REACT_APP_CARTURL}common/cart-list/${patientDetails.curebayPatientId}`;

    axios
      .get(url, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        // the API payload is in response.data
        console.log("Cart list for patient:", response.data.data.carts);
        // store it in state if you like
        setCartList(response.data.data.carts || []);
      })
      .catch((err) => {
        console.error(
          "Failed to fetch cart list:",
          err.response?.data || err.message
        );
      });
  }, [patientDetails.curebayPatientId]);

  const syncOrderSummaryFromCart = (cartData) => {
    if (!cartData) return;

    const amount = Number(cartData.amount);
    const discountAmount = Number(cartData.discountAmount) || 0;
    const paidAmount = Number(cartData.paidAmount);

    if (!Number.isNaN(amount)) {
      setMedicineBill(amount);
    }
    setTotalDiscount(discountAmount);
    if (!Number.isNaN(paidAmount)) {
      setTotalAmount(paidAmount);
    } else if (!Number.isNaN(amount)) {
      setTotalAmount(Math.max(0, amount - discountAmount));
    }
  };

  const applyCartDataFromResponse = (cartData) => {
    if (!cartData) return;

    if (cartData.cartId) {
      setCartId(cartData.cartId);
    }
    setMedicines(cartData.medicineItems || []);
    setMedicineDetails(cartData);
    syncOrderSummaryFromCart(cartData);

    const couponFromCart =
      cartData.couponCode ||
      cartData.voucherCode ||
      cartData.appliedCouponCode ||
      "";
    if (couponFromCart) {
      setAppliedCoupon(couponFromCart);
      setCouponInput(couponFromCart);
    } else {
      setAppliedCoupon("");
      setCouponInput("");
    }
  };

  const fetchMedicineCartDetails = async ({ showLoader = false } = {}) => {
    if (!patientDetails.curebayPatientId) {
      if (showLoader) setLoading(false);
      return null;
    }

    if (showLoader) setLoading(true);

    try {
      const response = await fetch(
        `${process.env.REACT_APP_CARTURL}medicine/details?patientId=${patientDetails.curebayPatientId}`
      );
      const data = await response.json();
      if (data.status === "OK") {
        applyCartDataFromResponse(data.data);
        return data.data;
      }
      return null;
    } catch (error) {
      console.error("Error fetching cart data:", error);
      return null;
    } finally {
      if (showLoader) setLoading(false);
    }
  };

  useEffect(() => {
    fetchMedicineCartDetails({ showLoader: true });
  }, [patientDetails.curebayPatientId]);

  useEffect(() => {
    if (
      medicineDetails?.amount != null ||
      medicineDetails?.paidAmount != null
    ) {
      syncOrderSummaryFromCart(medicineDetails);
      return;
    }

    const medBill = medicines.reduce(
      (sum, med) =>
        sum + (parseFloat(med.unitPrice) || 0) * (parseInt(med.quantity) || 1),
      0
    );

    setMedicineBill(medBill);
    setTotalDiscount(0);
    setTotalAmount(medBill);
  }, [medicines, medicineDetails]);

  // Check prescription documents when medicineDetails is available
  useEffect(() => {
    const checkPrescription = async () => {
      if (!medicineDetails?.patientOrderId) return;
      
      setCheckingPrescription(true);
      try {
        const prescriptionData = await checkPrescriptionDocuments(medicineDetails.patientOrderId);
        setPrescriptionDocuments(prescriptionData);
        
        // If prescription documents exist, mark as uploaded
        if (prescriptionData?.hasDocuments) {
          setPrescriptionUploaded(true);
        }
      } catch (error) {
        console.error("Error checking prescription documents:", error);
      } finally {
        setCheckingPrescription(false);
      }
    };

    checkPrescription();
  }, [medicineDetails?.patientOrderId]);

  const checkPrescriptionRequired = () => {
    console.log(medicines, "ftyguhijok");
    if (medicines?.length) {
      let list = medicines?.map((res) => res);
      let uploadPres = list?.filter((element) => element.drugCategory == "RX");
      console.log(uploadPres, list, "sdvisdhvoisdhoihdsovdsuovhgsduvs");
      if (uploadPres?.length > 0) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  };

  // Check prescription documents from API
  const checkPrescriptionDocuments = async (orderId) => {
    if (!orderId) return null;
    
    console.log("Checking prescription documents for orderId:", orderId);
    
    try {
      const token = localStorage.getItem("auth_token");
      const url = `${process.env.REACT_APP_CARTURL}common/prescription/${orderId}`;
      console.log("API URL:", url);
      
      const response = await fetch(url, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      
      const data = await response.json();
      console.log("Prescription documents check result:", data);
      
      if (data.status === "OK") {
        // Check if prescription documents exist (prescriptionDocs is array of URLs)
        const hasPrescriptionDocs = data.data.prescriptionDocs && data.data.prescriptionDocs.length > 0;
        const hasVisitIds = data.data.visitIds && data.data.visitIds.some(id => id && id.trim() !== '');
        
        const result = {
          hasDocuments: hasPrescriptionDocs || hasVisitIds,
          prescriptionDocs: data.data.prescriptionDocs || [],
          visitIds: data.data.visitIds || [],
          orderId: data.data.orderId
        };
        
        console.log("Prescription check result:", result);
        return result;
      }
      
      return null;
    } catch (error) {
      console.error("Error checking prescription documents:", error);
      return null;
    }
  };

  // Check if prescription upload is required
  const isPrescriptionUploadRequired = () => {
    if (!medicines?.length) return false;
    
    // Check if any medicine has prescriptionRequired = true OR drugCategory = "RX"
    const requiresPrescription = prescriptionNeeded && prescriptionData == null;
    
    // If prescription documents exist from API, don't require upload
    if (prescriptionDocuments?.hasDocuments) {
      return false;
    }
    
    return requiresPrescription && !prescriptionUploaded;
  };

  // Handle prescription file upload
  const handlePrescriptionUpload = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    // Validate file type
    const allowedTypes = ['image/jpeg', 'image/png', 'image/jpg', 'application/pdf'];
    if (!allowedTypes.includes(file.type)) {
      toast.error('Please upload a valid file (JPEG, PNG, JPG, or PDF)');
      return;
    }

    // Validate file size (max 5MB)
    if (file.size > 5 * 1024 * 1024) {
      toast.error('File size should be less than 5MB');
      return;
    }

    setPrescriptionFile(file);
    setUploadingPrescription(true);

    try {
      // Convert file to base64
      const base64 = await convertFileToBase64(file);
      
      // Upload prescription to API with the original file so type is correct
      await uploadPrescriptionFileToAPI(base64, file);
      
      setPrescriptionUploaded(true);
      toast.success('Prescription uploaded successfully!');
    } catch (error) {
      console.error('Error uploading prescription:', error);
      toast.error('Failed to upload prescription. Please try again.');
    } finally {
      setUploadingPrescription(false);
    }
  };

  // Convert file to base64
  const convertFileToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        const base64 = reader.result.split(',')[1]; // Remove data URL prefix
        resolve(base64);
      };
      reader.onerror = (error) => reject(error);
    });
  };

  // Upload prescription file to API
  const uploadPrescriptionFileToAPI = async (base64Data, sourceFile) => {
    const token = localStorage.getItem("auth_token");
    
    const resolveDocTypeFromFile = (file) => {
      if (!file || !file.type) return 'image';
      const mime = file.type.toLowerCase();
      if (mime === 'application/pdf') return 'pdf';
      if (mime === 'image/jpeg' || mime === 'image/jpg') return 'jpeg';
      if (mime === 'image/png') return 'png';
      return 'image';
    };

    const uploadPayload = {
      patientId:  patientDetails.curebayPatientId,
      orderId: medicineDetails?.patientOrderId,
      orderType: "MED",
      prescriptionDocuments: [
        {
          prescriptionDocData: base64Data,
          prescriptionDocType: resolveDocTypeFromFile(sourceFile),
        },
      ],
    };

    const response = await fetch(
      `${process.env.REACT_APP_CARTURL}common/upload-prescription`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(uploadPayload),
      }
    );

    if (!response.ok) {
      throw new Error('Failed to upload prescription');
    }

    const result = await response.json();
    console.log("Prescription upload result:", result);

    // After successful upload, immediately fetch latest prescription docs
    try {
      const orderIdToCheck = medicineDetails?.patientOrderId || uploadPayload.orderId;
      if (orderIdToCheck) {
        const refreshed = await checkPrescriptionDocuments(orderIdToCheck);
        setPrescriptionDocuments(refreshed);
        setPrescriptionUploaded(!!refreshed?.hasDocuments);
      }
    } catch (e) {
      console.warn('Failed to refresh prescription documents after upload:', e);
    }
  };

  const getFileExtension = (filename) => {
    if (!filename) return "";
    const parts = filename.split(".");
    return parts.length > 1 ? parts.pop().toLowerCase() : "";
  };

  // Manual test function for prescription API (for debugging)
  const testPrescriptionAPI = async (orderId = "999192855") => {
    console.log("Testing prescription API with orderId:", orderId);
    const result = await checkPrescriptionDocuments(orderId);
    console.log("Test result:", result);
    return result;
  };

  // Expose test function to window for console testing
  React.useEffect(() => {
    window.testPrescriptionAPI = testPrescriptionAPI;
    return () => {
      delete window.testPrescriptionAPI;
    };
  }, []);

  // Handle viewing prescription document from API
  const handleViewPrescriptionDoc = (doc, index) => {
    console.log("Viewing prescription document:", doc, "at index:", index);

    const isPdfUrl = (url) => {
      if (!url) return false;
      const lower = url.split('?')[0].toLowerCase();
      return lower.endsWith('.pdf');
    };
    
    // If the document is a URL string (from prescriptionDocs array), use modal preview
    if (typeof doc === 'string' && doc.startsWith('http')) {
      setPrescriptionPreview({ open: true, url: doc, isPdf: isPdfUrl(doc) });
    } else if (doc.url) {
      setPrescriptionPreview({ open: true, url: doc.url, isPdf: isPdfUrl(doc.url) });
    } else if (doc.signedUrl) {
      setPrescriptionPreview({ open: true, url: doc.signedUrl, isPdf: isPdfUrl(doc.signedUrl) });
    } else if (doc.fileName) {
      // Try to open via known storage base URL or env-configured base
      const gcsBase = process.env.REACT_APP_GCS_PUBLIC_BASE || 'https://storage.googleapis.com/curebay-nonprod-application-data/';
      const url = `${gcsBase}${doc.fileName}`;
      setPrescriptionPreview({ open: true, url, isPdf: isPdfUrl(url) });
    } else if (doc.prescriptionDocData) {
      // If it's base64 data, convert to blob URL and preview in modal
      const mimeType = doc.prescriptionDocType === 'pdf' ? 'application/pdf' : 'image/jpeg';
      const blob = new Blob([Uint8Array.from(atob(doc.prescriptionDocData), c => c.charCodeAt(0))], { type: mimeType });
      const url = URL.createObjectURL(blob);
      setPrescriptionPreview({ open: true, url, isPdf: mimeType === 'application/pdf' });
    } else {
      // Show document details in a toast
      toast.info(`Prescription Document ${index + 1} details: ${JSON.stringify(doc, null, 2)}`);
    }
  };

  // Handle viewing visit ID from API
  const handleViewVisitId = (visitId, index) => {
    console.log("Viewing visit ID:", visitId, "at index:", index);
    
    // You can implement visit details view here
    // For now, show the visit ID in a toast
    toast.info(`Visit ID ${index + 1}: ${visitId}`);
    
    // You could also open a modal with visit details or navigate to visit page
    // navigate(`/visit/${visitId}`);
  };

  // API: delete prescription file on server
  const deletePrescriptionFileFromAPI = async ({ fileName, orderId, orderType = 'MED' }) => {
    const token = localStorage.getItem('auth_token');
    const url = `${process.env.REACT_APP_CARTURL}common/remove-prescription`;
    const response = await fetch(url, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ fileName, orderId, orderType }),
    });
    if (!response.ok) {
      const text = await response.text().catch(() => '');
      throw new Error(`Delete failed ${response.status}: ${text}`);
    }
    return response.json().catch(() => ({}));
  };

  // Extract filename from GCS URL
  const extractFileNameFromUrl = (url) => {
    if (typeof url === 'string' && url.includes('storage.googleapis.com')) {
      // Extract filename from URL like: https://storage.googleapis.com/curebay-nonprod-application-data/PHOTO689802092025080345192.image
      const parts = url.split('/');
      return parts[parts.length - 1]; // Returns "PHOTO689802092025080345192.image"
    }
    return null;
  };

  // Handle deleting prescription document from API
  const handleDeletePrescriptionDoc = async (index) => {
    console.log("Deleting prescription document at index:", index);
    
    try {
      // Identify selected doc
      const currentDocs = prescriptionDocuments?.prescriptionDocs || [];
      const targetDoc = currentDocs[index];
      if (!targetDoc) {
        toast.error('Document not found');
        return;
      }

      // Extract fileName from URL (prescriptionDocs contains URLs like the API response)
      let fileName;
      if (typeof targetDoc === 'string') {
        // If targetDoc is a URL string, extract filename from it
        fileName = extractFileNameFromUrl(targetDoc);
      } else {
        // If targetDoc is an object, try to get fileName from properties
        fileName = targetDoc.fileName || targetDoc.name || targetDoc.documentName;
      }

      const orderId = medicineDetails?.patientOrderId || prescriptionDocuments?.orderId;
      
      if (!fileName || !orderId) {
        toast.error('Missing fileName or orderId to delete');
        return;
      }

      console.log('Deleting file:', fileName, 'for orderId:', orderId);

      await deletePrescriptionFileFromAPI({ fileName, orderId, orderType: 'MED' });

      // Refetch documents to stay in sync with server
      const refreshed = await checkPrescriptionDocuments(orderId);
      setPrescriptionDocuments(refreshed);
      setPrescriptionUploaded(!!refreshed?.hasDocuments);

      toast.success('Prescription document deleted');
      
    } catch (error) {
      console.error("Error deleting prescription document:", error);
      toast.error('Failed to remove prescription document');
    }
  };

  // Handle deleting visit ID from API
  const handleDeleteVisitId = async (index) => {
    console.log("Deleting visit ID at index:", index);
    
    try {
      // Create a copy of the current visit IDs
      const updatedVisitIds = [...prescriptionDocuments.visitIds];
      const deletedVisitId = updatedVisitIds[index];
      updatedVisitIds.splice(index, 1);
      
      // Update the state
      const updatedPrescriptionData = {
        ...prescriptionDocuments,
        visitIds: updatedVisitIds,
        hasDocuments: prescriptionDocuments.prescriptionDocs.length > 0 || updatedVisitIds.length > 0
      };
      
      setPrescriptionDocuments(updatedPrescriptionData);
      
      // If no documents left, mark as not uploaded
      if (!updatedPrescriptionData.hasDocuments) {
        setPrescriptionUploaded(false);
      }
      
      toast.success('Visit ID removed successfully');
      
      // Optionally, you can also call an API to delete from server
      // await deleteVisitIdFromAPI(prescriptionDocuments.orderId, deletedVisitId);
      
    } catch (error) {
      console.error("Error deleting visit ID:", error);
      toast.error('Failed to remove visit ID');
    }
  };

  // Server-side deletion functions (uncomment if you have delete APIs)
  /*
  const deletePrescriptionDocFromAPI = async (orderId, doc) => {
    const token = localStorage.getItem("auth_token");
    const response = await fetch(
      `${process.env.REACT_APP_CARTURL}common/prescription/${orderId}/document`,
      {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ documentId: doc.id || doc.documentId }),
      }
    );
    
    if (!response.ok) {
      throw new Error('Failed to delete prescription document from server');
    }
  };

  const deleteVisitIdFromAPI = async (orderId, visitId) => {
    const token = localStorage.getItem("auth_token");
    const response = await fetch(
      `${process.env.REACT_APP_CARTURL}common/prescription/${orderId}/visit`,
      {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ visitId }),
      }
    );
    
    if (!response.ok) {
      throw new Error('Failed to delete visit ID from server');
    }
  };
  */

  const handleProceed = async () => {
    if (!deliveryaddress) {
      toast.error("Please Select Delivery Address");
      return;
    }
 
    // Check if prescription is required but not uploaded
    if (isPrescriptionUploadRequired()) {
      toast.error("Please upload prescription before proceeding");
      return;
    }
 
    handleAddressConfirm();
 
    if (prescriptionNeeded && (prescriptionData || prescriptionDocuments?.hasDocuments)) {
      uploadPrescriptionToAPI();
    }
    console.log("xdcfgvhbj");
 
    const token = localStorage.getItem("auth_token");
    const tenantId = localStorage.getItem("tenantId");
    const clinicId = localStorage.getItem("clinicId");
    // const selectedMedicineDetails = medicinesData.filter((med) =>
    //   selectedMedicines.includes(med.id)
    // );
 
    // const selectedLabDetails = labTestsData.filter((lab) =>
    //   selectedLabs.includes(lab.id)
    // );
    // console.log(selectedMedicineDetails, selectedLabDetails, "fcgvhjiko");
    // const hospitalIds = new Set(checkedLabDetails.map((d) => d.labId));
    // if (hospitalIds.size > 1) {
    //   toast.error(
    //     "Select all test from the same lab or replace the tests in your cart"
    //   );
    //   return;
    // }
    const addressFields = [
      deliveryaddress.address1,
      deliveryaddress.deliveryCity,
      deliveryaddress.deliveryState,
      deliveryaddress.deliveryCountry,
      deliveryaddress.deliveryPinCode,
    ];
    console.log(selectedPatient, "medicineshjbjh");
    const PatientName = `${selectedPatient?.firstName ?? ""} ${selectedPatient?.lastName ?? ""}`.trim();
    const fullAddress = addressFields.filter(Boolean).join(", ");
    const payload = {
      clinicId: clinicId,
      // appointmentObjectId: selectedPatient?.id,
      patientPrescriptionObjectId: selectedPatient?.prescriptionId || null,
      patientName: PatientName || selectedPatient?.patientName,
      orderPlacedTo: "SMART_CLINIC",
      patientMobileNo: selectedPatient?.patientMobileNo || patientDetails?.mobileNumber,
      txnId: "",
      appointmentId: selectedPatient?.appointmentId || null,
      patientId: selectedPatient?.patientId,
 
      patientDrugPrescriptionList: {
        // e.g. "LABORDER-001" or pull from your cart details:
        drugOrderId: medicineDetails?.patientOrderId,
        drugs: medicines.map((item) => {
          const unitPrice = parseFloat(item.unitPrice) || 0;
          const quantity = parseInt(item.quantity) || 1;
          const lineDiscount =
            parseFloat(item.discountAmount) ||
            parseFloat(item.discountedAmount) ||
            0;
          const lineTotal =
            item.totalAmount != null
              ? parseFloat(item.totalAmount)
              : Math.max(0, unitPrice * quantity - lineDiscount);
          const discountedUnitPrice = Number(
            (Math.max(0, lineTotal) / Math.max(1, quantity)).toFixed(2)
          );
 
          return {
            composition: item.composition,
            afterBeforeFood: item.afterBeforeFood,
            type: item.type,
            dosage: item.dosage,
            drugName: item.drugName,
            drugName1: item.drugName1,
            duration: item.duration,
            drugCategory: item.drugCategory,
            form: item.form,
            frequency: item.frequency,
            instruction: item.instruction,
            medicineType: item.medicineType,
            pharmacyStockId: item.pharmacyStockId,
            drugMType: item.drugMType,
            quantity: item.quantity,
            specialAuthority: item.specialAuthority,
            status: 1,
            drugCode: item.drugId,
            drugType: item.drugType,
            amount: unitPrice,
            typeOfSell: item.medicineTypeOfSell,
            notes: item.notes,
            rate: unitPrice,
            discountedAmount: discountedUnitPrice,
            // med2: discountedUnitPrice,
            totalAmount: lineTotal,
          };
        }),
      },
      appoimentDetails: [],
      amount: medicineDetails?.amount ?? medicineBill,
      discountedAmount: medicineDetails?.paidAmount ,
      address: fullAddress || "",
      enquiryTickets: null,
    };
    console.log(payload, "payloadjhbjb");
 
    try {
      const response = await fetch(`${API_URL}orders/save`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          tenantId: tenantId,
        },
        body: JSON.stringify(payload),
      });
 
      const result = await response.json();
      console.log(result, "result");
      if (result.status === 200) {
        const orderId = result.data?.id;
        setorderid(orderId);
        // toast.success(result.message || "Order submitted successfully");
        setModalOpen(true);

        // After the order is placed, create a D2C ticket (like surgery & ambulance)
        // and link it back to the order.
        try {
          const hospitalId = localStorage.getItem("hospitalid") || "";
          const ticketPayload = {
            patientDetails: {
              patientId: selectedPatient?.patientId || patientId || "",
              medicaseId: "",
              patientName: PatientName || selectedPatient?.patientName || "",
              dob: patientDetails?.dob || "",
              gender: patientDetails?.gender || "",
              mobileNumber: String(
                selectedPatient?.patientMobileNo ||
                  patientDetails?.mobileNumber ||
                  ""
              ),
              email: patientDetails?.email || "",
              escallationNumber: "",
              address: fullAddress || patientDetails?.address || "",
              pincode: String(patientDetails?.pinCode || ""),
            },
            serviceDetailsMessage: "",
            tickeType: "MEDICINE",
            ticketSource: "HOSPITAL360",
            hospitalId: hospitalId,
          };

          const ticketRes = await fetch(
            `${process.env.REACT_APP_API_COMMAND_CENTER_URL}patient/add-ticket-d2c`,
            {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify(ticketPayload),
            }
          );
          const ticketData = await ticketRes.json();

          if (ticketRes.ok && ticketData?.status === 200 && ticketData?.data) {
            const ticketId = ticketData.data.id;
            await fetch(`${API_URL}createenquiry/order?orderId=${orderId}`, {
              method: "PUT",
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
                tenantId: tenantId,
              },
              body: JSON.stringify({
                ticketId: ticketId,
                ticketStatus: "INPROGRESS",
              }),
            });
          }
        } catch (ticketErr) {
          console.error("Failed to create/link D2C ticket:", ticketErr);
        }
      } else {
        toast.error(result.message || "Order submission failed");
      }
    } catch (error) {
      toast.error("Something went wrong while submitting order");
    }
  };


  
  const handlePay = async () => {
    if (paymentMode === "CASH") {
      // await confirmAppointment("CASH");
    }
  };
  const handleRemoveMedicine = async (medicineId) => {
    const cartPatientId = patientDetails.curebayPatientId || patientId;
    if (!cartPatientId || !cartId) return;

    setRemovingItems((prev) => new Set([...prev, medicineId]));

    try {
      const response = await fetch(
        `${process.env.REACT_APP_CARTURL}medicine/removeMedicine`,
        {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            cartId: cartId,
            id: medicineId,
            patientId: cartPatientId,
          }),
        }
      );

      if (response.ok) {
        setMedicines((prev) => prev.filter((med) => med.id !== medicineId));
      }
    } catch (error) {
      console.error("Error removing medicine:", error);
    } finally {
      setRemovingItems((prev) => {
        const newSet = new Set(prev);
        newSet.delete(medicineId);
        return newSet;
      });
    }
  };
  const handleQuantityChange = async (medicineId, change) => {
    const cartPatientId = patientDetails.curebayPatientId || patientId;
    if (!cartPatientId || !cartId) return;

    setUpdatingQuantity((prev) => new Set([...prev, medicineId]));

    try {
      const medicine = medicines.find((med) => med.id === medicineId);
      if (!medicine) return;

      const newQuantity = Math.max(
        1,
        (parseInt(medicine.quantity) || 1) + change
      );

      const response = await fetch(
        `${process.env.REACT_APP_CARTURL}medicine/update`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            cartId: cartId,
            id: medicineId,
            quantity: newQuantity,
            patientId: cartPatientId,
          }),
        }
      );
      const responseData = await response.json().catch(() => ({}));

      if (response.ok && responseData?.data) {
        applyCartDataFromResponse(responseData.data);
      } else if (response.ok) {
        setMedicines((prev) =>
          prev.map((med) =>
            med.id === medicineId ? { ...med, quantity: newQuantity } : med
          )
        );
      } else {
        toast.error(
          responseData?.message || "Failed to update medicine quantity"
        );
      }
    } catch (error) {
      console.error("Error updating quantity:", error);
    } finally {
      setUpdatingQuantity((prev) => {
        const newSet = new Set(prev);
        newSet.delete(medicineId);
        return newSet;
      });
    }
  };
  const limitTimeForLab = (timeParam) => {
    console.log(timeParam, "sdpfdibdhpisdhpb");
    if (moment(preferDate).isSame(moment().format("YYYY-MM-DD"))) {
      let current_time_in_hour = moment().hour();

      let am_or_pm = timeParam.value.substring(0, 5).split(" ")[1];
      let time_in_hours = Number(timeParam.value.substring(0, 5).split(" ")[0]);
      if (am_or_pm == "PM" && time_in_hours != 12) {
        time_in_hours += 12;
      }
      console.log(
        "current_time_in_hour:",
        current_time_in_hour + 4,
        "time_in_hours: ",
        time_in_hours
      );
      if (current_time_in_hour + 4 > time_in_hours) {
        return true;
      } else {
        return false;
      }
    }
    return false;
  };

  const handleAddressConfirm = async () => {
    try {
      // Validate patient address selection
      if (addressOption === "patient" && !selectedAddress) {
        toast.error("Please select a patient address");
        return;
      }

      const token = localStorage.getItem("auth_token");
      const cartIds = cartList.map((c) => c.cartId).filter(Boolean);
      if (cartIds.length === 0) {
        throw new Error("No carts available to update");
      }
      let addressPayloadBase;

      
      if (addressOption === "clinic") {
       

        // 3. Common address payload
        addressPayloadBase = {
          // deliveryMobileNumber: "9337482639",
          deliveryAddress1: hospitaldata?.address,
          // deliveryAddress2: "Acharya Vihar, Lane 8",
          deliveryCity: hospitaldata.city,
          deliveryState: hospitaldata.State,
          deliveryCountry: "India",
          deliveryPinCode: hospitaldata.pinCode,
          deliveryMobile: patientDetails?.mobileNumber,
          deliveryContactName: `${patientDetails?.firstName ?? ""} ${
            patientDetails?.lastName ?? ""
          }`.trim(),
          // latitude: 20.363914,
          // longitude: 85.79742,
        };
      } else if (addressOption === "patient") {
        // 3. Common address payload using selected address
        addressPayloadBase = {
          // deliveryMobileNumber: "9337482639",
          deliveryAddress1: selectedAddress?.address || "",
          deliveryAddress2: selectedAddress?.landmark || "",
          deliveryCity: selectedAddress?.state || "",
          deliveryState: selectedAddress?.state || "",
          deliveryCountry: selectedAddress?.country || "India",
          deliveryPinCode: selectedAddress?.pincode || "",
          deliveryMobile: patientDetails?.mobileNumber,
          deliveryContactName: `${patientDetails?.firstName ?? ""} ${
            patientDetails?.lastName ?? ""
          }`.trim(),
          // latitude: 20.363914,
          // longitude: 85.79742,
        };
      } else if (addressOption === "add") {
        // Validate required fields before saving address
        const errors = {};
        if (!houseNo.trim()) {
          errors.houseNo = "House number is required";
        } else if (houseNo.trim().length < 2) {
          errors.houseNo = "House number must be at least 2 characters";
        }
        
        if (!address1.trim()) {
          errors.address1 = "Landmark is required";
        } else if (address1.trim().length < 3) {
          errors.address1 = "Landmark must be at least 3 characters";
        }
        
        if (!pincode.trim()) {
          errors.pincode = "Pincode is required";
        } else if (!/^\d{6}$/.test(pincode)) {
          errors.pincode = "Pincode must be exactly 6 digits";
        }
        
        // If there are validation errors, show them and return
        if (Object.keys(errors).length > 0) {
          // Show first error
          const firstError = Object.values(errors)[0];
          toast.error(firstError);
          return;
        }
        
        // First, save the new address to addressbook
        try {
          const addressPayload = {
            address: houseNo,
            landmark: address1,
            state: fetchedState || stateField,
            pincode: pincode,
            country: fetchedCountry || "India",
            patientId: patientId,
          };

          const addressResponse = await axios.post(
            `${API_URL}addressbook`,
            addressPayload,
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
                tenantId: localStorage.getItem("tenantId"),
              },
            }
          );

         
          
          // Update the patient addresses list with the new address
          if (addressResponse.data && addressResponse.data.id) {
            const newAddress = {
              id: addressResponse.data.id,
              address: houseNo,
              landmark: address1,
              state: fetchedState || stateField,
              pincode: pincode,
              country: fetchedCountry || "India",
              patientId: patientId,
            };
            
            // Add new address to the list and select it
            setPatientAddresses(prev => [...prev, newAddress]);
            setSelectedAddress(newAddress);
            
            // Reset form fields after successful submission
            resetAddressForm();
            
            // toast.success("Address added successfully!");
          }
        } catch (addressError) {
          console.error("Failed to save address:", addressError);
          toast.error("Failed to save address. Please try again.");
          return; // Stop execution if address saving fails
        }

        // 3. Common address payload for delivery
        addressPayloadBase = {
          deliveryAddress1: houseNo,
          deliveryAddress2: address1,
          // deliveryLandmark: landmark,
          deliveryCity: city,
          deliveryState: fetchedState || stateField,
          deliveryPinCode: pincode,
          deliveryCountry: fetchedCountry || "India",
          deliveryMobile: patientDetails?.mobileNumber,
          deliveryContactName: `${patientDetails?.firstName ?? ""} ${
            patientDetails?.lastName ?? ""
          }`.trim(),
        };
      }
      const payload = {
        ...addressPayloadBase,
        cartIds, // sending array of cart IDs
      };
      try {
        const token = localStorage.getItem("auth_token");

        console.log(cartList, "cartList");
        const medCartId =
          cartList.find((cart) => cart.cartType === "MED")?.cartId || null;
        const payload = {
          ...addressPayloadBase,
          CartId: medCartId, // sending array of cart IDs
        };
        console.log(payload, "dfgyhujiko");
        const res = await fetch(
          `${process.env.REACT_APP_API_URL_PATIENTS}webhook/updateAddress`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`, // optional, if your API requires auth
            },
            body: JSON.stringify(payload),
          }
        );

        setDeliveryaddress({
          address1: addressPayloadBase.deliveryAddress1,
          deliveryCity: addressPayloadBase.deliveryCity,
          deliveryState: addressPayloadBase.deliveryState,
          deliveryCountry: addressPayloadBase.deliveryCountry,
          deliveryPinCode: addressPayloadBase.deliveryPinCode,
        });
      } catch (error) {
        console.error("Address update failed:", error);
        // toast.error("Failed to update address");
      }

      setAddressupdate(true);
      setaddressModalOpen(false);
    } catch (err) {
      console.error("handleAddressConfirm error:", err);
      toast.error(err.message || "Failed to update address");
    }
  };
  console.log(medicines, "cartListcartList");
  if (!patientDetails.curebayPatientId) {
    return (
      <OurLayouts>
        <div className="min-h-screen bg-gradient-to-br from-gray-50 via-blue-50/30 to-emerald-50/30 flex items-center justify-center p-4">
          {/* Animated Background Elements */}
          <div className="fixed inset-0 overflow-hidden pointer-events-none">
            <div className="absolute -top-40 -right-40 w-80 h-80 bg-gradient-to-br from-[#004172]/20 to-[#3cba84]/20 rounded-full blur-3xl animate-pulse"></div>
            <div className="absolute -bottom-40 -left-40 w-80 h-80 bg-gradient-to-br from-[#3cba84]/20 to-[#004172]/20 rounded-full blur-3xl animate-pulse delay-1000"></div>
          </div>

          <div className="relative bg-white/80 backdrop-blur-sm rounded-2xl shadow-2xl p-8 text-center max-w-md border border-white/20 animate-fadeIn">
            <div className="w-16 h-16 bg-gradient-to-r from-[#004172] to-[#3cba84] rounded-full flex items-center justify-center mx-auto mb-4 animate-bounce">
              <ShoppingCart className="w-8 h-8 text-white" />
            </div>
            <h2 className="text-xl font-bold text-gray-900 mb-3">
              No Patient Selected
            </h2>
            <p className="text-gray-600 mb-6">
              Please select a patient to view cart.
            </p>
            <button
              onClick={() => navigate("/BookService")}
              className="w-full bg-gradient-to-r from-[#004172] to-[#3cba84] text-white py-3 px-6 rounded-xl font-semibold hover:shadow-lg hover:scale-105 transition-all duration-300"
            >
              Go Back
            </button>
          </div>
        </div>
      </OurLayouts>
    );
  }

  const patientFullName =
    selectedPatient?.patientName ||
    `${patientDetails?.firstName || ""} ${patientDetails?.lastName || ""}`.trim();
  const patientInitials = patientFullName
    ? patientFullName
        .split(" ")
        .filter(Boolean)
        .map((n) => n[0])
        .join("")
        .slice(0, 2)
        .toUpperCase()
    : "—";

  const handleCopyCouponCode = (code) => {
    navigator.clipboard.writeText(code);
    toast.success("Coupon code copied");
  };

  const handleApplyCoupon = async (code) => {
    const value = (code || couponInput).trim();
    if (!value) {
      toast.error("Please enter a coupon code");
      return;
    }
    if (!cartId) {
      toast.error("Cart not ready. Please try again.");
      return;
    }
    if (applyingCoupon) return;

    setApplyingCoupon(true);
    try {
      const response = await fetch(
        `${process.env.REACT_APP_CARTURL}benefits/apply-benefits`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            cartId,
            couponCode: value,
            serviceType: "VOUCHER",
            cartType: "MED",
            isCureCoinApplied: "N",
          }),
        }
      );

      const data = await response.json().catch(() => ({}));

      if (response.ok && data?.data) {
        applyCartDataFromResponse(data.data);
        if (data.data.couponCode || value) {
          setAppliedCoupon(data.data.couponCode || value);
          setCouponInput(data.data.couponCode || value);
        }
        setCouponModalOpen(false);
        toast.success(data.message || "Coupon applied successfully");
      } else if (response.ok) {
        setAppliedCoupon(value);
        setCouponInput(value);
        setCouponModalOpen(false);
        toast.success("Coupon applied successfully");
        await fetchMedicineCartDetails();
      } else {
        toast.error(
          data?.message || data?.error || "Failed to apply coupon"
        );
      }
    } catch (error) {
      console.error("Error applying coupon:", error);
      toast.error("Failed to apply coupon");
    } finally {
      setApplyingCoupon(false);
    }
  };

  const handleRemoveCoupon = async (e) => {
    e?.stopPropagation?.();
    if (!cartId || !appliedCoupon || removingCoupon) return;

    setRemovingCoupon(true);
    try {
      const response = await fetch(
        `${process.env.REACT_APP_CARTURL}benefits/remove-benefits`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            cartId,
            cartType: "MED",
            serviceType: "VOUCHER",
            couponCode: appliedCoupon,
            isCureCoinApplied: "N",
          }),
        }
      );

      const data = await response.json().catch(() => ({}));

      if (response.ok) {
        setAppliedCoupon("");
        setCouponInput("");
        toast.success("Coupon removed successfully");
        await fetchMedicineCartDetails();
      } else {
        toast.error(
          data?.message || data?.error || "Failed to remove coupon"
        );
      }
    } catch (error) {
      console.error("Error removing coupon:", error);
      toast.error("Failed to remove coupon");
    } finally {
      setRemovingCoupon(false);
    }
  };

  const formattedAddress = [
    deliveryaddress.address1,
    deliveryaddress.deliveryCity,
    deliveryaddress.deliveryState,
    deliveryaddress.deliveryPinCode,
  ]
    .filter(Boolean)
    .join(", ");
  const appointmentDateLabel = selectedPatient?.whenAppointment
    ? moment(selectedPatient.whenAppointment).format("DD MMM YYYY")
    : "";

  if (loading) {
    return (
      <OurLayouts>
        <div className="min-h-screen bg-[#F8F9FA] flex items-center justify-center">
          <div className="text-center">
            <div className="relative">
              <div className="w-16 h-16 border-4 border-gray-200 rounded-full animate-spin"></div>
              <div className="absolute inset-0 w-16 h-16 border-4 border-transparent border-t-[#004172] rounded-full animate-spin"></div>
            </div>
            <p className="text-gray-600 mt-4 font-medium">
              Loading your cart...
            </p>
          </div>
        </div>
      </OurLayouts>
    );
  }

  return (
    <OurLayouts>
      <div className="min-h-screen bg-[#F8F9FA]">
        <div className="relative z-10 p-4 md:p-6 max-w-7xl mx-auto">
          <div className="mx-auto">
            {medicines.length === 0 ? (
              <div className=" p-12 text-center animate-fadeIn">
                <div className="w-20 h-20 bg-gradient-to-r from-[#004172] to-[#3cba84] rounded-full flex items-center justify-center mx-auto mb-6 animate-bounce">
                  <ShoppingCart className="w-10 h-10 text-white" />
                </div>
                <h2 className="text-2xl font-bold text-gray-900 mb-3">
                  Your cart is empty
                </h2>
                {/* <p className="text-gray-600 mb-8">
                  Add medicines to get started
                </p>
                <button
                  onClick={() => navigate("/schedule-service")}
                  className="bg-gradient-to-r from-[#004172] to-[#3cba84] text-white px-8 py-3 rounded-xl font-semibold inline-flex items-center gap-3 hover:shadow-lg hover:scale-105 transition-all duration-300"
                >
                  <Package className="w-5 h-5" />
                  Browse Medicines
                </button> */}
              </div>
            ) : (
              <>
                {/* Page Header */}
                <div className="flex items-center gap-3 mb-5">
                  <div className="w-9 h-9 rounded-full bg-[#0D6B6E] flex items-center justify-center shadow-sm">
                    <ShoppingCart className="w-4 h-4 text-white" />
                  </div>
                  <h2 className="text-xl font-bold text-gray-900 mb-0">
                    Cart Items
                  </h2>
                  <span className="min-w-[24px] h-6 px-1.5 rounded-full bg-[#0D6B6E] text-white text-xs font-semibold flex items-center justify-center">
                    {medicines.length}
                  </span>
                </div>

                {/* Patient Info Bar */}
                <div
                  className="rounded-xl p-4 mb-5 flex flex-wrap items-center justify-between gap-4 overflow-hidden"
                  style={{ ...CART_CARD_STYLE, background: PATIENT_STRIP_GRADIENT }}
                >
                  <div className="flex items-center gap-3 min-w-0">
                    <span className="w-11 h-11 rounded-full bg-[#0D6B6E] text-white flex items-center justify-center text-sm font-bold flex-shrink-0">
                      {patientInitials}
                    </span>
                    <div className="min-w-0">
                      <p className="font-bold text-gray-900 mb-0 text-sm truncate">
                        {patientFullName || "—"}
                      </p>
                      <p className="text-xs text-[#64748B] mb-0">
                        {[
                          patientDetails?.age ? `Age: ${patientDetails.age}` : null,
                          patientDetails?.gender,
                          selectedPatient?.patientMobileNo ||
                            patientDetails?.mobileNumber,
                        ]
                          .filter(Boolean)
                          .join(" / ")}
                      </p>
                    </div>
                  </div>
                  {selectedPatient?.appointmentId && (
                    <p className="text-sm text-[#64748B] mb-0 whitespace-nowrap">
                      Appt #{selectedPatient.appointmentId}
                      {appointmentDateLabel ? `, ${appointmentDateLabel}` : ""}
                    </p>
                  )}
                </div>

                <div className="grid lg:grid-cols-3 gap-5">
                  {/* Left Column — Medicine Details */}
                  <div className="lg:col-span-2">
                    {medicines?.length > 0 && (
                      <div className="bg-white overflow-hidden" style={CART_CARD_STYLE}>
                        <div
                          className="px-5 flex items-center justify-between"
                          style={{
                            background: CART_SECTION_HEADER_GRADIENT,
                            minHeight: 52,
                          }}
                        >
                          <div className="flex items-center gap-2">
                            <span className="w-7 h-7 rounded-full bg-white flex items-center justify-center flex-shrink-0 shadow-sm">
                              <Eye className="w-4 h-4 text-[#0D6B6E]" />
                            </span>
                            <h3 className="font-bold text-gray-900 mb-0 text-[15px]">
                              Medicine Details
                            </h3>
                          </div>
                          <span className="text-sm text-gray-500 font-medium">
                            {medicines.length} items
                          </span>
                        </div>

                        <div className="divide-y divide-gray-100">
                          {medicines.map((med, index) => {
                            const isRx = med.prescriptionRequired === true;
                            const unitPrice = parseFloat(med.unitPrice) || 0;
                            const quantity = parseInt(med.quantity) || 1;
                            const originalTotal = unitPrice * quantity;
                            const itemTotal =
                              med.totalAmount != null
                                ? parseFloat(med.totalAmount)
                                : originalTotal;
                            const discountAmount =
                              parseFloat(med.discountAmount) || 0;
                            const hasDiscount =
                              discountAmount > 0 ||
                              itemTotal < originalTotal - 0.009;
                            const discountPercent =
                              hasDiscount && originalTotal > 0
                                ? Math.round(
                                    ((discountAmount ||
                                      originalTotal - itemTotal) /
                                      originalTotal) *
                                      100
                                  )
                                : 0;

                            return (
                              <div
                                key={med.id}
                                className="px-5 py-4 hover:bg-gray-50/50 transition-colors"
                                style={{ animationDelay: `${index * 100}ms` }}
                              >
                                <div className="flex items-center gap-4">
                                  <div
                                    className={`w-14 h-14 rounded-xl flex items-center justify-center flex-shrink-0 ${getMedicineIconBoxClassName(isRx)}`}
                                  >
                                    {renderMedicineTypeIcon(med.medicineTypeOfSell, {
                                      prescriptionRequired: isRx,
                                    })}
                                  </div>

                                  <div className="flex-1 min-w-0">
                                    <div className="flex items-center gap-2 flex-wrap mb-0.5">
                                      <h3 className="text-sm font-bold text-[#0D6B6E] mb-0">
                                        {med.drugName}
                                      </h3>
                                      {isRx && (
                                        <span className="inline-flex items-center px-1.5 py-0.5 rounded text-[10px] font-bold bg-red-50 text-red-500 border border-red-200">
                                          Rx
                                        </span>
                                      )}
                                    </div>
                                    <p className="text-xs text-[#64748B] mb-0.5 capitalize">
                                      {med.medicineTypeOfSell}
                                    </p>
                                    <p className="text-xs text-[#64748B] mb-0">
                                      MRP ₹
                                      {(parseFloat(med.unitPrice) || 0).toFixed(
                                        2
                                      )}
                                    </p>
                                    {isRx && (
                                      <p className="text-[11px] text-orange-600 font-medium mt-0.5 mb-0">
                                        Prescription Required
                                      </p>
                                    )}
                                  </div>

                                  <div className="flex items-center gap-2 flex-shrink-0">
                                    <div className="flex items-center bg-white border border-gray-200 rounded-lg overflow-hidden">
                                      <button
                                        onClick={() =>
                                          handleQuantityChange(med.id, -1)
                                        }
                                        disabled={
                                          updatingQuantity.has(med.id) ||
                                          parseInt(med.quantity) <= 1
                                        }
                                        className="px-2.5 py-1.5 text-gray-500 hover:bg-gray-50 hover:text-[#0D6B6E] disabled:opacity-50 transition-colors"
                                      >
                                        <Minus className="w-3.5 h-3.5" />
                                      </button>
                                      <span className="px-3 py-1.5 text-sm font-semibold min-w-[36px] text-center border-x border-gray-200">
                                        {updatingQuantity.has(med.id) ? (
                                          <div className="animate-spin rounded-full h-3.5 w-3.5 border-2 border-[#0D6B6E] border-t-transparent mx-auto" />
                                        ) : (
                                          med.quantity
                                        )}
                                      </span>
                                      <button
                                        onClick={() =>
                                          handleQuantityChange(med.id, 1)
                                        }
                                        disabled={updatingQuantity.has(med.id)}
                                        className="px-2.5 py-1.5 text-gray-500 hover:bg-gray-50 hover:text-[#0D6B6E] disabled:opacity-50 transition-colors"
                                      >
                                        <Plus className="w-3.5 h-3.5" />
                                      </button>
                                    </div>

                                    <button
                                      onClick={() =>
                                        handleRemoveMedicine(med.id)
                                      }
                                      disabled={removingItems.has(med.id)}
                                      className="p-1.5 text-red-500 hover:text-red-600 hover:bg-red-50 rounded-lg transition-colors disabled:opacity-50"
                                    >
                                      {removingItems.has(med.id) ? (
                                        <div className="animate-spin rounded-full h-4 w-4 border-2 border-red-400 border-t-transparent" />
                                      ) : (
                                        <Trash2 className="w-4 h-4" />
                                      )}
                                    </button>
                                  </div>

                                  <div className="flex flex-col items-end gap-1 min-w-[120px] flex-shrink-0">
                                    {hasDiscount ? (
                                      <div className="flex items-center gap-2 flex-wrap justify-end">
                                        <span className="font-bold text-green-600 text-base leading-none">
                                          ₹{itemTotal.toFixed(2)}
                                        </span>
                                        <span className="text-sm text-gray-400 line-through leading-none">
                                          ₹{originalTotal.toFixed(2)}
                                        </span>
                                        {discountPercent > 0 && (
                                          <span className="text-[11px] font-bold text-red-500 bg-pink-50 px-1.5 py-0.5 rounded leading-none">
                                            {discountPercent}% OFF
                                          </span>
                                        )}
                                      </div>
                                    ) : (
                                      <span className="font-bold text-[#0D6B6E] text-sm">
                                        ₹{itemTotal.toFixed(2)}
                                      </span>
                                    )}
                                  </div>
                                </div>
                              </div>
                            );
                          })}
                        </div>

                        {/* Prescription upload — left column */}
                        {isPrescriptionUploadRequired() && (
                          <div className="mx-5 mb-5 mt-1">
                            <div className="bg-[#FFF0E0] border border-[#FFCD9B] rounded-xl p-4">
                              <div className="flex items-start gap-3">
                                <FileText className="w-5 h-5 text-orange-500 flex-shrink-0 mt-0.5" />
                                <div className="flex-1 min-w-0">
                                  <p className="text-sm text-orange-700 mb-3">
                                    A prescription is required for{" "}
                                    {medicines
                                      .filter(
                                        (m) => m.prescriptionRequired === true
                                      )
                                      .map((m) => m.drugName)
                                      .join(", ")}
                                    . Please upload your prescription to
                                    proceed.
                                  </p>
                                  {!prescriptionUploaded ? (
                                    <label className="inline-block">
                                      <input
                                        type="file"
                                        accept=".jpg,.jpeg,.png,.pdf"
                                        onChange={handlePrescriptionUpload}
                                        className="hidden"
                                        disabled={uploadingPrescription}
                                      />
                                      <span className="inline-flex items-center gap-2 px-4 py-2 border border-orange-400 text-orange-600 rounded-lg text-sm font-semibold cursor-pointer hover:bg-orange-100 transition-colors">
                                        {uploadingPrescription ? (
                                          <>
                                            <div className="animate-spin rounded-full h-4 w-4 border-2 border-orange-500 border-t-transparent" />
                                            Uploading...
                                          </>
                                        ) : (
                                          <>
                                            <Upload className="w-4 h-4" />
                                            Upload Prescription
                                          </>
                                        )}
                                      </span>
                                    </label>
                                  ) : (
                                    <div className="space-y-2">
                                      <div className="flex items-center gap-2 text-green-600">
                                        <CheckCircle className="w-4 h-4" />
                                        <span className="text-sm font-medium">
                                          Prescription uploaded successfully!
                                        </span>
                                      </div>
                                      <div className="flex items-center gap-3 bg-white rounded-lg p-2 border border-orange-100">
                                        <span className="text-sm text-gray-700 flex-1 truncate">
                                          {prescriptionFile?.name ||
                                            "Prescription"}
                                        </span>
                                        <button
                                          onClick={() => {
                                            if (prescriptionFile) {
                                              const url =
                                                URL.createObjectURL(
                                                  prescriptionFile
                                                );
                                              window.open(url, "_blank");
                                            }
                                          }}
                                          className="px-2 py-1 text-xs bg-blue-500 text-white rounded hover:bg-blue-600"
                                        >
                                          Preview
                                        </button>
                                        <button
                                          onClick={() => {
                                            setPrescriptionFile(null);
                                            setPrescriptionUploaded(false);
                                            toast.success(
                                              "Prescription removed"
                                            );
                                          }}
                                          className="px-2 py-1 text-xs bg-red-500 text-white rounded hover:bg-red-600"
                                        >
                                          Delete
                                        </button>
                                      </div>
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        )}

                        {prescriptionDocuments?.hasDocuments &&
                          !isPrescriptionUploadRequired() && (
                            <div className="mx-5 mb-5 mt-1">
                              <div className="bg-green-50 border border-green-200 rounded-xl p-4">
                                <div className="flex items-center gap-2 text-green-700 mb-3">
                                  <CheckCircle className="w-4 h-4" />
                                  <span className="text-sm font-semibold">
                                    Prescription Documents Available
                                  </span>
                                </div>
                                <div className="space-y-2">
                                  {prescriptionDocuments.prescriptionDocs.map(
                                    (doc, index) => {
                                      const fileName =
                                        extractFileNameFromUrl(doc) ||
                                        `Document ${index + 1}`;
                                      return (
                                        <div
                                          key={index}
                                          className="flex items-center gap-3 bg-white rounded-lg p-2 border border-green-100"
                                        >
                                          <span className="text-sm text-gray-700 flex-1 truncate">
                                            {fileName}
                                          </span>
                                          <button
                                            onClick={() =>
                                              handleViewPrescriptionDoc(
                                                doc,
                                                index
                                              )
                                            }
                                            className="h-7 w-7 bg-blue-500 text-white rounded-full hover:bg-blue-600 flex items-center justify-center"
                                            title="View document"
                                          >
                                            <Eye className="w-3.5 h-3.5" />
                                          </button>
                                          <button
                                            onClick={() =>
                                              handleDeletePrescriptionDoc(
                                                index
                                              )
                                            }
                                            className="h-7 w-7 bg-red-500 text-white rounded-full hover:bg-red-600 flex items-center justify-center"
                                            title="Delete document"
                                          >
                                            <Trash2 className="w-3.5 h-3.5" />
                                          </button>
                                        </div>
                                      );
                                    }
                                  )}
                                  {prescriptionDocuments.visitIds
                                    .filter(
                                      (visitId) =>
                                        visitId && visitId.trim() !== ""
                                    )
                                    .map((visitId, index) => (
                                      <div
                                        key={`visit-${index}`}
                                        className="flex items-center gap-3 bg-white rounded-lg p-2 border border-green-100"
                                      >
                                        <div className="flex-1 min-w-0">
                                          <span className="text-sm text-gray-700">
                                            Visit ID {index + 1}
                                          </span>
                                          <p className="text-xs text-green-600 mb-0">
                                            {visitId}
                                          </p>
                                        </div>
                                        <button
                                          onClick={() =>
                                            handleViewVisitId(visitId, index)
                                          }
                                          className="px-2 py-1 text-xs bg-blue-500 text-white rounded hover:bg-blue-600"
                                        >
                                          View
                                        </button>
                                        <button
                                          onClick={() =>
                                            handleDeleteVisitId(index)
                                          }
                                          className="px-2 py-1 text-xs bg-red-500 text-white rounded hover:bg-red-600"
                                        >
                                          Delete
                                        </button>
                                      </div>
                                    ))}
                                </div>
                              </div>
                            </div>
                          )}

                        {checkingPrescription && (
                          <div className="mx-5 mb-5">
                            <div className="bg-blue-50 border border-blue-200 rounded-xl p-3">
                              <div className="flex items-center gap-2 text-blue-700">
                                <div className="animate-spin rounded-full h-4 w-4 border-2 border-blue-500 border-t-transparent" />
                                <span className="text-sm">
                                  Checking prescription documents...
                                </span>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    )}
                  </div>

                  {/* Right Column — Coupons, Order Summary & Address */}
                  <div className="lg:col-span-1 space-y-4">
                    {appliedCoupon ? (
                      <div
                        className="w-full flex items-center justify-between gap-3 px-4 py-3.5 rounded-xl"
                        style={{ background: "#5FAA8E" }}
                      >
                        <div className="flex items-center gap-3 min-w-0">
                          <span className="w-9 h-9 flex-shrink-0 rounded-lg bg-[#004172] flex items-center justify-center text-white">
                            <Percent className="w-4 h-4" strokeWidth={2.5} />
                          </span>
                          <span className="font-bold text-white text-[15px] truncate">
                            Avail Coupons
                          </span>
                        </div>
                        <button
                          type="button"
                          onClick={handleRemoveCoupon}
                          disabled={removingCoupon}
                          className="flex-shrink-0 px-4 py-1.5 text-xs font-bold text-white border-2 border-white rounded-lg bg-transparent hover:bg-white/10 transition-colors disabled:opacity-60"
                        >
                          {removingCoupon ? "REMOVING..." : "REMOVE"}
                        </button>
                      </div>
                    ) : (
                      <button
                        type="button"
                        onClick={() => setCouponModalOpen(true)}
                        className="w-full flex items-center justify-between gap-3 px-4 py-3.5 rounded-xl border transition-colors hover:opacity-95"
                        style={{
                          background: "#EEF6FB",
                          borderColor: "#B8D4E8",
                        }}
                      >
                        <div className="flex items-center gap-3 min-w-0">
                          <span
                            className="w-9 h-9 flex-shrink-0 rounded-lg flex items-center justify-center text-white"
                            style={{ background: "#004172" }}
                          >
                            <Percent className="w-4 h-4" strokeWidth={2.5} />
                          </span>
                          <span className="font-bold text-[#004172] text-[15px] truncate">
                            Avail Coupons
                          </span>
                        </div>
                        <span className="flex-shrink-0 px-4 py-1.5 text-xs font-bold text-[#004172] border-2 border-[#004172] rounded-lg bg-white">
                          APPLY
                        </span>
                      </button>
                    )}

                    <div className="bg-white overflow-hidden" style={CART_CARD_STYLE}>
                      <div
                        className="px-5 flex items-center"
                        style={{
                          background: CART_SECTION_HEADER_GRADIENT,
                          minHeight: 52,
                        }}
                      >
                        <h3 className="font-bold text-gray-900 mb-0 text-[15px]">
                          Order Summary
                        </h3>
                      </div>

                      <div className="px-5 py-4 space-y-3">
                        {medicines?.length > 0 && (
                          <div className="flex justify-between text-sm text-gray-600">
                            <span>Medicine Bill</span>
                            <span className="font-semibold text-gray-900">
                              ₹ {medicineBill.toFixed(2)}
                            </span>
                          </div>
                        )}

                        <div className="flex justify-between text-sm text-gray-600">
                          <span>Total Discount</span>
                          <span
                            className={`font-semibold ${
                              totalDiscount > 0
                                ? "text-green-600"
                                : "text-gray-900"
                            }`}
                          >
                            {totalDiscount > 0
                              ? `- ₹ ${totalDiscount.toFixed(2)}`
                              : `₹ ${totalDiscount.toFixed(2)}`}
                          </span>
                        </div>

                        <div className="border-t border-gray-200 pt-3">
                          <div className="flex justify-between items-center">
                            <span className="font-bold text-[#004172]">
                              Payable Amount
                            </span>
                            <span className="font-bold text-[#004172] text-lg">
                              ₹ {totalAmount.toFixed(2)}
                            </span>
                          </div>
                        </div>
                      </div>

                      <div className="px-5 pb-5">
                        <button
                          onClick={() => {
                            if (consentGiven) {
                              setConsentModalOpen(true);
                            } else {
                              handleProceed();
                            }
                          }}
                          disabled={isPrescriptionUploadRequired()}
                          className={`w-full py-3 px-6 rounded-xl font-semibold flex items-center justify-center gap-2 transition-all duration-200 ${
                            isPrescriptionUploadRequired()
                              ? "bg-gray-300 text-gray-500 cursor-not-allowed"
                              : "bg-[#0D6B6E] text-white hover:bg-[#0A9E8A] shadow-sm"
                          }`}
                        >
                          <CreditCard className="w-5 h-5" />
                          {isPrescriptionUploadRequired()
                            ? "Upload Prescription First"
                            : "Proceed to Payment"}
                        </button>
                      </div>
                    </div>

                    <div className="bg-white overflow-hidden" style={CART_CARD_STYLE}>
                      <div
                        className="px-5 flex items-center gap-2"
                        style={{
                          background: CART_SECTION_HEADER_GRADIENT,
                          minHeight: 52,
                        }}
                      >
                        <span className="w-7 h-7 rounded-full bg-white flex items-center justify-center flex-shrink-0 shadow-sm">
                          <MapPin className="w-4 h-4 text-[#0D6B6E]" />
                        </span>
                        <h3 className="font-bold text-gray-900 mb-0 text-[15px]">
                          Delivery Address
                        </h3>
                      </div>
                      <div className="p-5">
                        {/* <span className="inline-block px-2.5 py-0.5 rounded-md bg-[#D4EDE9] text-[#0D6B6E] text-xs font-semibold mb-2">
                          Patient Address
                        </span> */}
                        <p className="text-sm text-gray-700 leading-relaxed mb-4">
                          {formattedAddress || "—"}
                        </p>
                        <button
                          onClick={() => setaddressModalOpen(true)}
                          className="inline-flex items-center gap-2 px-3 py-1.5 text-[13px] font-semibold text-[#0D6B6E] border border-[#0D6B6E] rounded-md bg-white hover:bg-teal-50 transition-colors"
                        >
                          <Pencil className="w-3.5 h-3.5" />
                          Change Address
                        </button>
                      </div>
                    </div>

                    <div
                      className="rounded-xl px-4 py-3 flex items-center justify-center gap-2 text-xs text-gray-600"
                      style={{ ...CART_CARD_STYLE, background: "#F9FAFB" }}
                    >
                      <Shield className="w-3.5 h-3.5 text-[#0A9E8A] flex-shrink-0" />
                      Secure checkout — all payments encrypted
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>

          {couponModalOpen && (
            <div
              className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4"
              onClick={() => setCouponModalOpen(false)}
            >
              <div
                className="bg-white rounded-2xl shadow-2xl w-full max-w-lg overflow-hidden"
                onClick={(e) => e.stopPropagation()}
              >
                <div className="px-5 py-4 flex items-center justify-between border-b border-gray-100">
                  <h3 className="text-lg font-bold text-gray-900 mb-0">
                    Select Coupon
                  </h3>
                  <button
                    type="button"
                    onClick={() => setCouponModalOpen(false)}
                    className="w-8 h-8 flex items-center justify-center text-gray-500 hover:text-gray-800 hover:bg-gray-100 rounded-full transition-colors"
                    aria-label="Close"
                  >
                    <X className="w-5 h-5" />
                  </button>
                </div>

                <div className="px-5 py-5">
                  <div className="relative mb-5">
                    <input
                      type="text"
                      value={couponInput}
                      onChange={(e) => setCouponInput(e.target.value)}
                      placeholder="Select Coupon Code or Enter Corporate Email Ad..."
                      className="w-full pr-20 pl-4 py-3 text-sm border border-gray-900 rounded-xl outline-none focus:ring-2 focus:ring-[#3cba84]/30"
                    />
                    <button
                      type="button"
                      onClick={() => handleApplyCoupon()}
                      disabled={applyingCoupon}
                      className="absolute right-3 top-1/2 -translate-y-1/2 text-sm font-semibold text-[#3cba84] hover:text-[#2da06d] disabled:opacity-50"
                    >
                      {applyingCoupon ? "Applying..." : "Apply"}
                    </button>
                  </div>

                  <div
                    className="rounded-xl p-4 space-y-4"
                    style={{ background: "#EEF6FB" }}
                  >
                    {AVAILABLE_COUPONS.map((coupon) => (
                      <div key={coupon.code}>
                        <div className="flex items-center justify-between gap-2 mb-3">
                          <span className="inline-flex items-center gap-2 px-3 py-1.5 text-sm font-semibold text-gray-900 border border-gray-900 rounded-md bg-white">
                            {coupon.code}
                            <button
                              type="button"
                              onClick={() => handleCopyCouponCode(coupon.code)}
                              className="text-gray-600 hover:text-[#004172] transition-colors"
                              aria-label={`Copy ${coupon.code}`}
                            >
                              <Copy className="w-4 h-4" />
                            </button>
                          </span>
                          <button
                            type="button"
                            onClick={() => handleApplyCoupon(coupon.code)}
                            disabled={applyingCoupon}
                            className="text-sm font-semibold text-[#3cba84] hover:text-[#2da06d] disabled:opacity-50"
                          >
                            {applyingCoupon ? "Applying..." : "Apply"}
                          </button>
                        </div>
                        <p className="text-sm text-gray-800 mb-1">
                          {coupon.rxDiscount}
                        </p>
                        <p className="text-sm text-gray-800 mb-0">
                          {coupon.otcDiscount}
                        </p>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          )}

          {addressModalOpen && (
            <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
              <div className="bg-white rounded-2xl shadow-2xl w-full max-w-2xl overflow-hidden">
                {/* Header */}
                <div className="bg-gradient-to-r from-[#004172] to-[#3cba84] text-white px-5 py-4 flex items-start justify-between gap-4">
                  <div className="flex items-start gap-3 min-w-0">
                    <span className="w-10 h-10 rounded-full bg-white/20 flex items-center justify-center flex-shrink-0">
                      <MapPin className="w-5 h-5 text-white" />
                    </span>
                    <div className="min-w-0">
                      <h3 className="text-lg font-bold mb-0.5">
                        Select Delivery Address
                      </h3>
                      <p className="text-white/90 text-sm mb-0">
                        Choose where to deliver medicines for{" "}
                        {patientFullName || "Patient"}
                      </p>
                    </div>
                  </div>
                  <button
                    type="button"
                    onClick={() => setaddressModalOpen(false)}
                    className="w-9 h-9 rounded-full bg-white/20 flex items-center justify-center hover:bg-white/30 flex-shrink-0 transition-colors"
                    aria-label="Close"
                  >
                    <X className="w-5 h-5" />
                  </button>
                </div>

                <div className="px-5 py-5">
                  {/* Tabs */}
                  <div className="flex gap-2 mb-5">
                    <button
                      type="button"
                      onClick={() => setAddressOption("clinic")}
                      className={`flex-1 py-2.5 px-3 rounded-lg text-sm font-semibold transition-colors ${
                        addressOption === "clinic"
                          ? "bg-[#0D6B6E] text-white shadow-sm"
                          : "bg-white text-[#0D6B6E] border border-gray-200 hover:bg-gray-50"
                      }`}
                    >
                      Organization Address
                    </button>
                    <button
                      type="button"
                      onClick={() => setAddressOption("patient")}
                      className={`flex-1 py-2.5 px-3 rounded-lg text-sm font-semibold transition-colors ${
                        addressOption === "patient"
                          ? "bg-[#0D6B6E] text-white shadow-sm"
                          : "bg-white text-[#0D6B6E] border border-gray-200 hover:bg-gray-50"
                      }`}
                    >
                      Patient Address
                    </button>
                    <button
                      type="button"
                      onClick={() => {
                        setAddressOption("add");
                        resetAddressForm();
                      }}
                      className={`flex-1 py-2.5 px-3 rounded-lg text-sm font-semibold transition-colors ${
                        addressOption === "add"
                          ? "bg-[#0D6B6E] text-white shadow-sm"
                          : "bg-white text-[#0D6B6E] border border-gray-200 hover:bg-gray-50"
                      }`}
                    >
                      Add New Address
                    </button>
                  </div>

                  {/* Content */}
                  {addressOption === "add" ? (
                    <form className="space-y-4">
                      <input
                        type="text"
                        placeholder="House no | Apartment name *"
                        className="w-full border border-gray-200 rounded-lg px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-[#0D6B6E]/30 focus:border-[#0D6B6E]"
                        value={houseNo}
                        onChange={(e) => setHouseNo(e.target.value)}
                      />
                      <input
                        type="text"
                        placeholder="Address *"
                        className="w-full border border-gray-200 rounded-lg px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-[#0D6B6E]/30 focus:border-[#0D6B6E]"
                        value={address1}
                        onChange={(e) => setAddress1(e.target.value)}
                      />
                      <div className="flex gap-3">
                        <input
                          type="text"
                          placeholder="Pincode *"
                          className="flex-1 border border-gray-200 rounded-lg px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-[#0D6B6E]/30 focus:border-[#0D6B6E]"
                          value={pincode}
                          maxLength={6}
                          onChange={(e) => {
                            const value = e.target.value.replace(/\D/g, "");
                            setPincode(value);
                            if (value.length === 6) {
                              fetchAddressByPincode(value);
                            }
                          }}
                          onKeyPress={(e) => {
                            if (!/[0-9]/.test(e.key)) {
                              e.preventDefault();
                            }
                          }}
                        />
                        <select
                          className="flex-1 border border-gray-200 rounded-lg px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-[#0D6B6E]/30 focus:border-[#0D6B6E]"
                          value={city}
                          onChange={(e) => setCity(e.target.value)}
                        >
                          <option value="">Select Area</option>
                          {areaOptions.map((area) => (
                            <option key={area.key} value={area.value}>
                              {area.label}
                            </option>
                          ))}
                        </select>
                      </div>
                      <input
                        type="text"
                        placeholder="State *"
                        className="w-full border border-gray-200 rounded-lg px-4 py-3 text-sm bg-gray-50"
                        value={fetchedState}
                        readOnly
                      />
                      <input
                        type="text"
                        placeholder="Country *"
                        className="w-full border border-gray-200 rounded-lg px-4 py-3 text-sm bg-gray-50"
                        value={fetchedCountry}
                        readOnly
                      />
                    </form>
                  ) : addressOption === "clinic" ? (
                    <div className="rounded-xl border border-[#B8DFDC] bg-[#EEF6F5] p-4">
                      <p className="text-xs font-bold tracking-wide text-[#0D6B6E] mb-1">
                        Organization Address
                      </p>
                      <p className="text-sm text-gray-700 mb-0 leading-relaxed">
                        {[
                          hospitaldata?.address,
                          hospitaldata?.pinCode,
                          hospitaldata?.city || clinicaddress?.city,
                          hospitaldata?.state,
                          hospitaldata?.country,
                        ]
                          .filter((part) => part != null && String(part).trim() !== "")
                          .join(", ") || "—"}
                      </p>
                      </div>
                  ) : (
                    <div>
                      {patientAddresses.length > 0 ? (
                        <div className="max-h-72 overflow-y-auto space-y-3 pr-1">
                          {patientAddresses.map((address, index) => {
                            const isSelected =
                              selectedAddress?.id === address.id;
                            const addressLabel =
                              index === 0 ? "HOME" : "OTHER";

                            return (
                              <div
                                key={address.id}
                                role="button"
                                tabIndex={0}
                                className={`rounded-xl border p-4 cursor-pointer transition-colors ${
                                  isSelected
                                    ? "bg-[#EEF6F5] border-[#B8DFDC]"
                                    : "bg-white border-gray-200 hover:bg-gray-50"
                                }`}
                                onClick={() => setSelectedAddress(address)}
                                onKeyDown={(e) => {
                                  if (e.key === "Enter" || e.key === " ") {
                                    e.preventDefault();
                                    setSelectedAddress(address);
                                  }
                                }}
                              >
                                <div className="flex items-start gap-3">
                                  <div
                                    className={`mt-0.5 w-5 h-5 rounded-full border-2 flex items-center justify-center flex-shrink-0 ${
                                      isSelected
                                        ? "border-[#0D6B6E]"
                                        : "border-gray-300"
                                    }`}
                                  >
                                    {isSelected && (
                                      <div className="w-2.5 h-2.5 rounded-full bg-[#0D6B6E]" />
                                    )}
                                  </div>
                                  <input
                                    type="radio"
                                    name="address"
                                    value={address.id}
                                    checked={isSelected}
                                    onChange={() =>
                                      setSelectedAddress(address)
                                    }
                                    className="sr-only"
                                  />
                                  <div className="flex-1 min-w-0">
                                    <p
                                      className={`text-xs font-bold tracking-wide mb-1 ${
                                        isSelected
                                          ? "text-[#0D6B6E]"
                                          : "text-gray-500"
                                      }`}
                                    >
                                      {addressLabel}
                                    </p>
                                    <p className="text-sm text-gray-700 mb-0 leading-relaxed">
                                      {address.address}, {address.landmark},{" "}
                                      {address.state} - {address.pincode}
                                    </p>
                                  </div>
                                  <button
                                    type="button"
                                    className="inline-flex items-center gap-1 text-sm font-medium text-[#0D6B6E] hover:text-[#0a5a5d] flex-shrink-0"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      setAddressToEdit(address);
                                      setEditHouseNo(address.address || "");
                                      setEditAddress1(address.landmark || "");
                                      setEditPincode(address.pincode || "");
                                      setEditFetchedState(
                                        address.state || ""
                                      );
                                      setEditFetchedCountry(
                                        address.country || "India"
                                      );
                                      setEditErrors({});
                                      setEditAddressModalOpen(true);
                                    }}
                                  >
                                    <Pencil className="w-3.5 h-3.5" />
                                    Edit
                                  </button>
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      ) : (
                        <p className="text-sm text-gray-500 text-center py-8 mb-0">
                          No addresses found for this patient
                        </p>
                      )}
                    </div>
                  )}

                  {/* Footer */}
                  <div className="mt-6 flex justify-end gap-3 pt-2">
                    <button
                      type="button"
                      onClick={() => setaddressModalOpen(false)}
                      className="px-5 py-2.5 rounded-lg border border-gray-300 text-gray-700 text-sm font-medium hover:bg-gray-50 transition-colors"
                    >
                      Cancel
                    </button>
                    <button
                      type="button"
                      onClick={handleAddressConfirm}
                      className="px-5 py-2.5 rounded-lg bg-[#0D6B6E] text-white text-sm font-semibold hover:bg-[#0a5a5d] transition-colors inline-flex items-center gap-2"
                    >
                      <Check className="w-4 h-4" />
                      Confirm Address
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>

        <PaymentModeModal
          isOpen={modalOpen}
          onClose={() => setModalOpen(false)}
          onPay={handlePay}
          setPaymentMode={setPaymentMode}
          isLoggingIn={isLoggingIn}
          paymentMode={paymentMode}
          paymentItem={orderid}
          paymenttype="Order"
          venderid={`LAB_${labCartDetails?.patientLabTestOrderId},MED_${medicineDetails?.patientOrderId}`}
        />
        {consentModalOpen && (
          <ConsentModal
            visible={consentModalOpen}
            onClose={() => setConsentModalOpen(false)}
            patientId={patientId}
            mobileNumber={
              selectedPatient?.patientMobileNo || patientDetails.mobileNumber
            }
            serviceType="CUREBAY_SERVICE"
            onConsentComplete={() => {
              setConsentGiven(true);
              setConsentModalOpen(false);
              handleProceed();
            }}
          />
        )}
      </div>

      {prescriptionPreview.open && (
        <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50" onClick={() => setPrescriptionPreview({ open: false, url: null })}>
          <div className="bg-white rounded-lg shadow-xl max-w-3xl w-full overflow-hidden" onClick={(e) => e.stopPropagation()}>
            <div className="flex justify-between items-center px-4 py-2 border-b">
              <h3 className="text-base font-semibold">Prescription Preview</h3>
              <button onClick={() => setPrescriptionPreview({ open: false, url: null })} className="text-2xl leading-none">&times;</button>
            </div>
            <div className="p-4 bg-gray-50 flex items-center justify-center" style={{ maxHeight: '80vh' }}>
              {prescriptionPreview.isPdf ? (
                <iframe title="Prescription PDF" src={prescriptionPreview.url || ''} className="w-full" style={{ height: '70vh' }} />
              ) : (
                <img src={prescriptionPreview.url || ''} alt="Prescription" className="max-h-[70vh] w-auto object-contain" />
              )}
            </div>
          </div>
        </div>
      )}

      <style jsx>{`
        @keyframes fadeIn {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @keyframes slideInUp {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        .animate-fadeIn {
          animation: fadeIn 0.6s ease-out;
        }

        .animate-slideInUp {
          animation: slideInUp 0.6s ease-out both;
        }
      `}</style>

      {/* Edit Address Modal */}
      {editAddressModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg shadow-xl max-w-2xl w-full mx-4 max-h-[90vh] overflow-y-auto">
            <div className="flex items-center justify-between p-6 border-b border-gray-200">
              <h2 className="text-xl font-semibold text-gray-900">Edit Address</h2>
              <button
                onClick={() => {
                  setEditAddressModalOpen(false);
                  setAddressToEdit(null);
                }}
                className="text-gray-400 hover:text-gray-600 transition-colors"
              >
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>
            
            <div className="p-6">
              <div className="space-y-6">
                {/* House no | Apartment name */}
                <div>
                  <input
                    type="text"
                    placeholder="House no | Apartment name *"
                    className={`w-full border rounded-lg px-4 py-3 text-gray-700 placeholder-gray-500 focus:outline-none focus:ring-2 focus:border-transparent transition-all duration-200 ${
                      editErrors.houseNo 
                        ? 'border-red-500 focus:ring-red-500' 
                        : 'border-gray-300 focus:ring-blue-500'
                    }`}
                    value={editHouseNo}
                    onChange={(e) => setEditHouseNo(e.target.value)}
                    required
                  />
                  {editErrors.houseNo && (
                    <p className="text-red-500 text-sm mt-1">{editErrors.houseNo}</p>
                  )}
                </div>

                {/* Landmark */}
                <div>
                  <input
                    type="text"
                    placeholder="Landmark *"
                    className={`w-full border rounded-lg px-4 py-3 text-gray-700 placeholder-gray-500 focus:outline-none focus:ring-2 focus:border-transparent transition-all duration-200 ${
                      editErrors.address1 
                        ? 'border-red-500 focus:ring-red-500' 
                        : 'border-gray-300 focus:ring-blue-500'
                    }`}
                    value={editAddress1}
                    onChange={(e) => setEditAddress1(e.target.value)}
                    required
                  />
                  {editErrors.address1 && (
                    <p className="text-red-500 text-sm mt-1">{editErrors.address1}</p>
                  )}
                </div>

                {/* Pincode and State */}
                <div className="flex space-x-4">
                  <div className="flex-1">
                    <input
                      type="text"
                      placeholder="Pincode *"
                      className={`w-full border rounded-lg px-4 py-3 text-gray-700 placeholder-gray-500 focus:outline-none focus:ring-2 focus:border-transparent transition-all duration-200 ${
                        editErrors.pincode 
                          ? 'border-red-500 focus:ring-red-500' 
                          : 'border-gray-300 focus:ring-blue-500'
                      }`}
                      value={editPincode}
                      maxLength={6}
                      onChange={(e) => {
                        const value = e.target.value.replace(/\D/g, ''); // Only allow numbers
                        setEditPincode(value);
                        
                        // Clear error when user starts typing
                        if (editErrors.pincode) {
                          setEditErrors(prev => ({ ...prev, pincode: '' }));
                        }
                        
                        // Trigger API call when pincode is 6 digits
                        if (value.length === 6) {
                          console.log("Edit Pincode is 6 digits, calling API for:", value);
                          fetchEditAddressByPincode(value);
                        }
                      }}
                      onKeyPress={(e) => {
                        if (!/[0-9]/.test(e.key)) {
                          e.preventDefault();
                        }
                      }}
                      required
                    />
                    {editErrors.pincode && (
                      <p className="text-red-500 text-sm mt-1">{editErrors.pincode}</p>
                    )}
                  </div>
                  <div className="flex-1">
                    <input
                      type="text"
                      placeholder="State *"
                      className="w-full border border-gray-300 rounded-lg px-4 py-3 text-gray-500 bg-gray-50 focus:outline-none transition-all duration-200"
                      value={editFetchedState}
                      readOnly
                    />
                  </div>
                </div>

                {/* Country */}
                <div>
                  <input
                    type="text"
                    placeholder="Country *"
                    className="w-full border border-gray-300 rounded-lg px-4 py-3 text-gray-500 bg-gray-50 focus:outline-none transition-all duration-200"
                    value={editFetchedCountry}
                    readOnly
                  />
                </div>

                {/* Buttons */}
                <div className="flex justify-center space-x-4 pt-6 border-t border-gray-200">
                  <button
                    onClick={() => {
                      setEditAddressModalOpen(false);
                      setAddressToEdit(null);
                    }}
                    className="py-3 px-8 rounded-xl font-semibold flex items-center justify-center gap-2 transition-all duration-300 bg-gray-500 text-white hover:bg-gray-600 hover:shadow-lg"
                  >
                    Cancel
                  </button>
                  <button
                    onClick={handleEditAddressSubmit}
                    className="py-3 px-8 rounded-xl font-semibold flex items-center justify-center gap-2 transition-all duration-300 bg-gradient-to-r from-[#004172] to-[#3cba84] text-white hover:shadow-lg hover:scale-105"
                  >
                    Update Address
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </OurLayouts>
  );
}
